export const translation = {
  nav_products: '产品中心',
  nav_production_scale: '生产规模',
  nav_brand_strength: '品牌实力',
  nav_contact: '联系我们',
  nav_view_all: '查看全部',
  nav_language_label: '语言',

  cat_nail_guns: '锂电钉枪系列',
  cat_garden_tools: '园林系列',
  cat_brushless: '无刷锂电系列',
  cat_workshop: '专用工坊工具',
  cat_sharpening: '专业磨削类',

  cat_nail_4v: '4V',
  cat_nail_20v: '20V',
  cat_nail_ac: 'AC',

  cat_garden_chainsaw: '电链锯与修枝锯',
  cat_garden_pole: '高枝及伸缩系列',
  cat_garden_maintenance: '园林养护专用',

  cat_brushless_impact_drill: '螺丝刀与电钻',
  cat_brushless_impact_driver: '起子机与冲击扳手',
  cat_brushless_angle_grinder: '角磨机',

  cat_workshop_polisher: '汽车抛光机',
  cat_workshop_sander: '砂磨与表面处理',
  cat_workshop_glue_gun: '电热熔胶枪',

  cat_sharpening_workbench: '多功能磨削工作台',
  cat_sharpening_drill_repair: '钻头修复机',
  cat_sharpening_engraving: '雕刻工具',

  nail_guns_hero_title: '锂电钉枪系列',
  nail_guns_hero_subtitle: '专业级锂电钉枪，覆盖 4V / 20V / AC 全系列',
  nail_guns_hero_desc: '满足各类施工场景需求',
  nail_guns_page_title: '锂电钉枪系列',
  nail_guns_page_desc: '专业级锂电钉枪，覆盖 4V / 20V / AC 全系列，满足各类施工场景需求',
  nail_guns_products_count: '款产品',
  brushless_products_count: '款产品',
  workshop_products_count: '款产品',
  sharpening_products_count: '款产品',

  garden_tools_hero_title: '园林工具系列',
  garden_tools_hero_subtitle: '专业园林养护工具，涵盖链锯、高枝锯、绿篱机等全系列',
  garden_tools_hero_desc: '满足各类园林作业需求',
  garden_tools_page_title: '园林工具系列',
  garden_tools_page_desc: '专业园林养护工具，涵盖链锯、高枝锯、绿篱机等全系列，满足各类园林作业需求',
  garden_tools_products_count: '款产品',

  brushless_hero_title: '无刷锂电系列',
  brushless_hero_subtitle: '高效无刷电机技术，覆盖冲击钻、冲击起子机、角磨机全系列',
  brushless_hero_desc: '强劲动力，持久耐用',
  brushless_page_title: '无刷锂电系列',
  brushless_page_desc: '高效无刷电机技术，覆盖冲击钻、冲击起子机、角磨机全系列，强劲动力，持久耐用',

  workshop_hero_title: '专用工坊工具系列',
  workshop_hero_subtitle: '专为汽车美容、木工车间、维修工坊设计的专业工具系列',
  workshop_hero_desc: '涵盖抛光、砂磨、粘接等多种工艺需求，助力工坊高效作业，打造精品工艺',
  workshop_page_title: '专用工坊工具系列',
  workshop_page_desc: '为专业工坊量身定制的高性能工具，从汽车抛光到表面处理，从精密粘接到材料打磨，全方位满足工坊多样化作业需求',

  sharpening_hero_title: '专业磨刀系列',
  sharpening_hero_subtitle: '专业级磨刀与雕刻工具，涵盖多功能磨削工作台、钻头修复机、雕刻工具等全系列产品',
  sharpening_hero_desc: '精密设计，高效耐用，满足各类专业磨削和雕刻需求',
  sharpening_page_title: '专业磨刀系列',
  sharpening_page_desc: '提供全方位的磨削和雕刻解决方案，从多功能磨削工作台到精密钻头修复机，再到专业雕刻工具，满足各类专业需求',

  hero1_subtitle: 'LEIMING TOOLS',
  hero1_title: '专业电动工具制造商',
  hero1_desc: '50年专注电动工具研发与制造',
  hero1_cta: '了解更多',
  hero2_subtitle: 'INNOVATION',
  hero2_title: '创新驱动 品质领先',
  hero2_desc: '500+专利技术 全球认证',
  hero2_cta: '查看产品',
  hero3_subtitle: 'QUALITY',
  hero3_title: '匠心品质 值得信赖',
  hero3_desc: 'ISO认证 严格质检',
  hero3_cta: '品质保证',
  hero4_subtitle: 'SERVICE',
  hero4_title: '全球服务 贴心保障',
  hero4_desc: '200+服务中心 24小时响应',
  hero4_cta: '联系我们',
  hero5_subtitle: 'PARTNERSHIP',
  hero5_title: '携手共赢 共创未来',
  hero5_desc: '全球战略合作伙伴',
  hero5_cta: '成为合作伙伴',
  latest_products: '最新产品',
  product_showcase: '产品展示',
  more_products: '更多产品',
  new_brushless_drill: '新款无刷锂电钻',
  new_cordless_nail_gun: '新款无绳钉枪',
  product_tag_new: 'NEW',
  new_cordless_nail_gun_home: '新型气缸钉枪',


  product_cordless_impact_wrench: '无绳冲击扳手',
  product_cordless_circular_saw: '无绳圆锯',
  product_cordless_angle_grinder: '无绳角磨机',
  product_cordless_jigsaw: '无绳曲线锯',
  product_cordless_reciprocating_saw: '无绳往复锯',

  cat_title: '探索产品系列',
  cat1_title: '电动工具',
  cat1_count: '500+ 产品',
  cat2_title: '手动工具',
  cat2_count: '300+ 产品',
  cat3_title: '工具存储',
  cat3_count: '150+ 产品',
  cat4_title: '户外设备',
  cat4_count: '200+ 产品',
  shop_now: '立即选购',

  prod_label: '生产规模',
  prod_title: '生产规模',
  prod_subtitle: '全球领先的电动工具制造基地',
  stat1_num: '300+',
  stat1_label: '产品型号',
  stat2_num: '40,000㎡',
  stat2_label: '生产基地',
  stat3_num: '100+',
  stat3_label: '销售国家',
  stat4_num: '10+',
  stat4_label: '销售渠道',
  stat5_num: '500人',
  stat5_label: '专业团队',
  facility_title: '先进生产设施',
  fac1_title: '自动化生产线',
  fac1_desc: '引进国际先进的自动化生产设备，确保产品质量稳定可靠',
  fac2_title: '质量检测中心',
  fac2_desc: '配备专业检测设备，每件产品经过严格质检',
  fac3_title: '环保生产',
  fac3_desc: '采用环保材料和工艺，符合国际环保标准',
  fac4_title: '快速交付',
  fac4_desc: '完善的物流体系，确保产品快速送达全球',

  brand_label: 'BRAND STRENGTH',
  brand_title: '品牌实力',
  brand_subtitle: '全球信赖的专业工具品牌',
  mile1_year: '1998-2005',
  mile1_title: '上海起点  品牌诞生',
  mile1_desc: '开始专注电动工具制造',
  mile2_year: '2006-2018',
  mile2_title: '技术深耕  资质完善',
  mile2_desc: '产品出口全球50+国家',
  mile3_year: '2019-2019',
  mile3_title: '无锡双公司落地  产销分离',
  mile3_desc: '获得100+项专利技术',
  mile4_year: '2020-2025',
  mile4_title: '2020年起四大公司协同  8年全链成熟',
  mile4_desc: '成为全球前三工具品牌',
  cert_title: '资质认证与荣誉',
  cert1: 'ISO 14001 环境管理体系认证',
  cert2: 'BSCI 社会责任认证',
  cert3: 'CE 欧洲安全认证',
  cert4: 'UL 美国安全认证',
  cert5: 'GS 德国安全认证',
  cert6: 'CQC 中国质量认证中心产品认证',
  cert7: '超过120项实用新型与发明专利',
  cert8: '上海电器行业协会理事单位',
  cert9: '连续8年获评“守合同重信用企业”',
  partner_title: '全球战略合作伙伴',
  partner1_name: 'Home Depot',
  partner1_desc: '北美最大建材零售商',
  partner2_name: "Lowe's",
  partner2_desc: '美国知名家居建材连锁',
  partner3_name: 'Amazon',
  partner3_desc: '全球电商平台战略合作',
  partner4_name: 'Grainger',
  partner4_desc: '工业用品分销巨头',

  deep_title: '深耕电动工具行业',
  deep_subtitle: '专业、专注、专心',
  deep_stat1_num: '50年',
  deep_stat1_label: '行业经验',
  deep_stat2_num: '500+',
  deep_stat2_label: '专利技术',
  deep_stat3_num: '100+',
  deep_stat3_label: '国家地区',
  deep_stat4_num: '1000万+',
  deep_stat4_label: '用户信赖',
  feat1_title: '品质保证',
  feat1_desc: '严格质检，每件产品都经过多道工序检验',
  feat2_title: '全球服务',
  feat2_desc: '200+服务中心，24小时快速响应',
  feat3_title: '研发创新',
  feat3_desc: '持续投入研发，引领行业技术发展',
  feat4_title: '产品丰富',
  feat4_desc: '500+产品型号，满足各类需求',
  feat5_title: '安全可靠',
  feat5_desc: '通过国际安全认证，使用更放心',

  cta_title: '寻找优质合作伙伴',
  cta_subtitle: '携手共创美好未来，期待与您的合作',
  cta_btn: '立即咨询',

  contact_title: '联系我们',
  contact_us_label: 'CONTACT US',
  contact_subtitle: '我们随时为您提供专业服务',
  contact_address_label: '公司地址',
  contact_address: '上海市松江区洞泾镇茂盛路202弄1号',
  contact_phone_label: '联系电话',
  contact_phone: '+86 400-888-8888',
  contact_mobile_label: '手机',
  contact_mobile: '+86 150 0031 5400',
  contact_landline_label: '座机',
  contact_landline: '+86 21 64199981',
  contact_email_label: '电子邮箱',
  contact_email: 'cherry@dongweitools.net',
  contact_time_label: '工作时间',
  contact_time_value: '周一至周五  09:00 - 18:00',
  contact_company_title: '专业工具制造商',
  contact_company_subtitle: '全球领先 · 品质卓越 · 值得信赖',
  form_title: '发送消息',
  form_subtitle: '填写以下信息，我们将在24小时内回复',
  form_name: '姓名',
  form_phone: '电话',
  form_email: '邮箱',
  form_company: '公司名称',
  form_message: '留言内容',
  form_required: '*',
  form_name_placeholder: '请输入您的姓名',
  form_phone_placeholder: '请输入联系电话',
  form_email_placeholder: '请输入您的邮箱地址',
  form_company_placeholder: '请输入公司名称（选填）',
  form_message_placeholder: '请描述您的需求或问题...',
  form_submit: '立即发送',
  form_sending: '发送中...',
  form_success: '发送成功！我们会在尽快回复您。',
  form_error: '发送失败，请稍后重试。',
  form_cancel: '取消',

  footer_company_desc: '专业电动工具制造商，50年行业经验，全球信赖',
  footer_products: '产品中心',
  footer_support: '客户支持',
  footer_company: '关于我们',
  footer_copyright: '版权所有',

  maintenance_title: '网站正在维护中',
  maintenance_subtitle: '给您带来的不便，我们深表歉意。',
  maintenance_timestamp: '当前时间',
  maintenance_contact: '如有紧急事宜，请联系我们',

  product_specs: '产品参数',
  spec_voltage: '电压',
  spec_power: '功率',
  spec_weight: '重量',
  spec_battery: '电池',
  spec_charge_time: '充电时间',
  spec_speed: '转速',
  spec_max_torque: '最大扭矩',
  spec_chuck_size: '夹头尺寸',
  spec_nail_type: '钉型',
  spec_nail_length: '钉长范围',
  spec_magazine: '容钉量',
  spec_firing_mode: '打钉模式',
  spec_blade_length: '刀片长度',
  spec_cutting_capacity: '切割能力',
  spec_disc_size: '盘面尺寸',
  spec_opm: '振荡速度',
  spec_grinding_wheel: '砂轮尺寸',
  spec_temperature: '工作温度',
  spec_glue_diameter: '胶棒直径',
  spec_sequential: '顺序打钉',
  spec_dimensions: '外形尺寸',
  spec_noise_level: '噪音等级',
  spec_color: '颜色',
  spec_warranty: '保修期',
  spec_certification: '认证标准',
  spec_max_pressure: '最大气压',

  product_highlights: '产品亮点',
  product_overview: '产品概述',
  product_model: '型号',
  accessories_title: '配件与零件',
  breadcrumb_home: '首页',
  breadcrumb_nail_guns: '锂电钉枪系列',

  nail_4v_acc_1_name: 'Nail',
  nail_4v_acc_1_desc: 'Type 47# / BN1810: 15mm(5/8")',
  nail_4v_acc_2_name: 'Staple',
  nail_4v_acc_2_desc: 'T50#: 6-14mm(1/4"- 35/64" )',
  nail_4v_acc_3_name: 'Staple',
  nail_4v_acc_3_desc: '53#',
  nail_4v_acc_4_name: '超紧凑型弹夹',
  nail_4v_acc_4_desc: '100 枚容量可视化弹夹',
  nail_4v_acc_5_name: '精准保险触头',
  nail_4v_acc_5_desc: '精准安全触头保险',
  nail_4v_acc_6_name: '人体工程学贴合握柄',
  nail_4v_acc_6_desc: '人体工程学防滑握柄',
  nail_4v_acc_7_name: 'Charging type',
  nail_4v_acc_7_desc: 'USB Type-C',
  nail_4v_acc_8_name: '用户手册',
  nail_4v_acc_8_desc: '详细操作指南，快速上手',
  nail_ac_acc_1_name: 'AC重型电源线',
  nail_ac_acc_1_desc: '2m重型电源线，稳定持续供电',
  nail_ac_acc_2_name: '电源保护器',
  nail_ac_acc_2_desc: '内联式电涌保护开关，保护设备安全',
  nail_ac_acc_3_name: '工具收纳箱',
  nail_ac_acc_3_desc: '坚固工具箱，方便携带存放',
  nail_ac_acc_4_name: '专用钉型钉包',
  nail_ac_acc_4_desc: '配套专用型钉，保证最佳打钉效果',
  nail_ac_acc_5_name: '护目镜',
  nail_ac_acc_5_desc: '专业防护眼镜，安全作业',
  nail_ac_acc_6_name: '壁挂存储支架',
  nail_ac_acc_6_desc: '车间壁挂支架，工具整洁收纳',
  nail_ac_acc_7_name: '清洁保养套装',
  nail_ac_acc_7_desc: '专业保养工具，保持最佳状态',
  nail_ac_acc_8_name: '用户手册',
  nail_ac_acc_8_desc: '详细操作指南，快速上手',

  accessory_1_name: '20V锂电池',
  accessory_1_desc: '大容量锂电池，持续稳定供电',
  accessory_2_name: '快充充电器',
  accessory_2_desc: '60分钟快充，高效便捷',
  accessory_3_name: '工具箱',
  accessory_3_desc: '坚固工具箱，方便携带存放',
  accessory_4_name: '配件套装',
  accessory_4_desc: '常用替换零件，延长使用寿命',
  accessory_5_name: '护目镜',
  accessory_5_desc: '专业防护，安全作业',
  accessory_6_name: '皮带钩',
  accessory_6_desc: '方便挂载，随时取用',
  accessory_7_name: '清洁保养套装',
  accessory_7_desc: '专业保养工具，保持最佳状态',
  accessory_8_name: '用户手册',
  accessory_8_desc: '详细操作指南，快速上手',

  garden_accessory_1_name: '20V锂电池',
  garden_accessory_1_desc: '大容量锂电池，持续稳定供电',
  garden_accessory_2_name: '快充充电器',
  garden_accessory_2_desc: '60分钟快充，高效便捷',
  garden_accessory_3_name: '替换刀片',
  garden_accessory_3_desc: '高品质替换刀片，保持最佳切割性能',
  garden_accessory_4_name: '工具箱',
  garden_accessory_4_desc: '坚固工具箱，方便携带存放',
  garden_accessory_5_name: '防护手套',
  garden_accessory_5_desc: '专业防护手套，安全作业',
  garden_accessory_6_name: '刀片磨刀工具',
  garden_accessory_6_desc: '保持刀片锋利，延长使用寿命',
  garden_accessory_7_name: '清洁保养套装',
  garden_accessory_7_desc: '专业保养工具，保持最佳状态',
  garden_accessory_8_name: '用户手册',
  garden_accessory_8_desc: '详细操作指南，快速上手',

  all_products_nav: '所有产品',


  //12V 起子机key

  brushless_pt_name: '可拆卸批头收纳夹',
  brushless_pt_desc: '具备 3 个标准六角孔位，可稳固收纳 3 枚常用批头，确保作业时随取随用，告别寻找配件的烦恼。',



  // brushless_accessory_battery: '锂电池',
  // brushless_accessory_battery_desc: '大容量锂电池，快充长续航，带电量显示',
  // brushless_accessory_charger: '智能充电器',
  // brushless_accessory_charger_desc: '快充技术，智能识别电池，安全高效充电',
  // brushless_accessory_drill_bits: '钻头套装',
  // brushless_accessory_drill_bits_desc: '多规格钻头套装，适用于木材、金属和混凝土',
  // brushless_accessory_case: '工具箱',
  // brushless_accessory_case_desc: '坚固工具箱，收纳所有配件，方便携带存放',
  // brushless_accessory_belt_clip: '皮带夹',
  // brushless_accessory_belt_clip_desc: '可调节皮带夹，随时取用',
  // brushless_accessory_side_handle: '侧手柄',
  // brushless_accessory_side_handle_desc: '辅助手柄，增强操控稳定性',
  // brushless_accessory_depth_gauge: '深度尺',
  // brushless_accessory_depth_gauge_desc: '精确控制钻孔深度，确保作业精度',
  // brushless_accessory_manual: '用户手册',
  // brushless_accessory_manual_desc: '详细操作指南，快速上手',

  workshop_accessory_polishing_pads: '抛光盘套装',
  workshop_accessory_polishing_pads_desc: '多硬度抛光盘，适合粗抛和精抛',
  workshop_accessory_backing_plate: '托盘',
  workshop_accessory_backing_plate_desc: '高品质托盘，牢固固定抛光盘',
  workshop_accessory_polishing_compound: '抛光蜡',
  workshop_accessory_polishing_compound_desc: '专业抛光蜡，去除划痕，恢复漆面光泽',
  workshop_accessory_microfiber_towels: '超细纤维毛巾',
  workshop_accessory_microfiber_towels_desc: '柔软吸水，不伤漆面，适合清洁和抛光',
  workshop_accessory_extension_cord: '延长线',
  workshop_accessory_extension_cord_desc: '延长作业范围',
  workshop_accessory_carrying_bag: '工具包',
  workshop_accessory_carrying_bag_desc: '便携工具包，方便携带存放',
  workshop_accessory_safety_glasses: '护目镜',
  workshop_accessory_safety_glasses_desc: '专业防护眼镜，保护眼睛安全',
  workshop_accessory_manual: '用户手册',
  workshop_accessory_manual_desc: '详细操作指南和保养说明',

  sharpening_accessory_grinding_wheels: '砂轮套装',
  sharpening_accessory_grinding_wheels_desc: '多种目数砂轮，满足粗磨和精磨需求',
  sharpening_accessory_angle_guide: '角度导轨',
  sharpening_accessory_angle_guide_desc: '精密角度控制导轨，确保每次磨削角度一致',
  sharpening_accessory_honing_compound: '研磨膏',
  sharpening_accessory_honing_compound_desc: '专业研磨膏，去除划痕，恢复刃口锋利度',
  sharpening_accessory_safety_shield: '防护罩',
  sharpening_accessory_safety_shield_desc: '透明防护罩，防止磨削碎屑飞溅',
  sharpening_accessory_work_light: '工作灯',
  sharpening_accessory_work_light_desc: 'LED工作灯，为精密磨削提供充足照明',
  sharpening_accessory_carrying_case: '工具箱',
  sharpening_accessory_carrying_case_desc: '坚固工具箱，方便存放和携带',
  sharpening_accessory_manual: '用户手册',
  sharpening_accessory_manual_desc: '详细操作指南，快速上手',

  spec_val_color_black_orange: '黑色 / 橙色',
  spec_val_color_silver_black: '银色 / 黑色',
  spec_val_color_black_red: '黑色 / 红色',
  spec_val_warranty_24: '24个月',
  spec_val_warranty_12: '12个月',
  spec_val_nails_80: '80颗',
  spec_val_nails_110: '110颗',
  spec_val_nail_f: 'F型直钉',
  spec_val_nail_t: 'T型钉',
  spec_val_nail_j: 'J型钉',
  spec_val_nail_u: 'U型骑马钉',
  spec_val_nail_n: 'N型卷钉',
  spec_val_nail_b: 'B型钉',
  spec_val_nail_c: 'C型卷钉',
  spec_val_nail_d: 'D型钉',
  spec_val_nail_g: 'G型专业钉',
  spec_val_nail_e: 'E型钉',

  nail_gun_name_J_120: '4V 钉枪',
  nail_gun_name_J_125: '4V 钉枪',
  nail_gun_name_J_139: '4V 钉枪',
  nail_gun_name_J_126: '4V 钉枪',
  nail_gun_name_J_153: '4V 钉枪',
  nail_gun_name_lk_4v_n50: 'LK-4V-N50 迷你N型卷钉枪',
  nail_gun_name_lk_4v_b18: 'LK-4V-B18 迷你B型钉枪',
  nail_gun_name_lk_4v_c25: 'LK-4V-C25 迷你C型卷钉枪',
  nail_gun_name_lk_4v_d30: 'LK-4V-D30 迷你D型钉枪',
  nail_gun_name_lk_4v_e40: 'LK-4V-E40 迷你E型钉枪',
  
  nail_gun_name_J_128: '20V 锂电三合一专业级码钉/直钉枪',
  nail_gun_name_J_129: '20V 锂电三合一专业级码钉/直钉枪',
  nail_gun_name_J_133: '20V 锂电二合一码钉/直钉枪',
  nail_gun_name_J_145: '20V 锂电三合一专业级码钉/直钉枪',
  nail_gun_name_J_147: '20V 锂电专业级电缆固线枪',
  nail_gun_name_J_150: '20V 无刷 18GA 氮气动力二合一钉枪',
  nail_gun_name_J_156: '20V 锂电二合一码钉/直钉枪',
  nail_gun_name_lk_20v_d70: 'LK-20V-D70 锂电D型钉枪',
  nail_gun_name_lk_20v_e80: 'LK-20V-E80 锂电E型钉枪',
  nail_gun_name_lk_20v_g100: 'LK-20V-G100 锂电旗舰钉枪',
  
  nail_gun_name_J_112: '专业级有源二合一电钉枪',
  nail_gun_name_J_115: '专业级有源极致轻便型钉枪',
  nail_gun_name_J_118: '专业级有源极致轻便型钉枪',
  nail_gun_name_J_119: '专业级有源极致轻便型钉枪',
  nail_gun_name_J_123: '专业级有源紧凑型钉枪',
  nail_gun_name_lk_ac_b50: 'LK-AC-B50 电动B型钉枪',
  nail_gun_name_lk_ac_c60: 'LK-AC-C60 电动C型卷钉枪',
  nail_gun_name_lk_ac_d70: 'LK-AC-D70 电动D型钉枪',
  nail_gun_name_lk_ac_e80: 'LK-AC-E80 电动E型钉枪',
  nail_gun_name_lk_ac_g100: 'LK-AC-G100 电动旗舰钉枪',

  brushless_drill_card_desc: '20V无刷锂电冲击钻',
  brushless_wrench_card_desc: '20V无刷锂电冲击扳手',
  brushless_driver_card_desc: '20V无刷锂电冲击起子机',
  brushless_grinder_card_desc: '20V无刷锂电角磨机',

  nail_4v_description: '本4V迷你锂电钉枪采用超轻量设计，整机仅0.8kg，单手即可轻松操控。4V锂电池充电90分钟即可完成约300颗钉的连续作业，适用于室内木工与家具拼装等精细施工场景。防滑橡胶握把设计保障长时间使用的舒适体验，是家装爱好者与木工从业者的理想工具。',
  nail_4v_f15_desc: '4V 钉枪',
  nail_4v_f20_desc: '4V 钉枪',
  nail_4v_t50_desc: '4V 钉枪',
  nail_4v_j64_desc: '4V 钉枪',
  nail_4v_u22_desc: '4V 钉枪',
  nail_4v_n50_desc: '20V 钉枪',
  nail_4v_b18_desc: '20V 钉枪',
  nail_4v_c25_desc: '20V 钉枪',
  nail_4v_d30_desc: '20V 钉枪',
  nail_4v_e40_desc: '20V 钉枪',
  nail_20v_f30_desc: '20V 钉枪',
  nail_20v_f50_desc: '20V 钉枪',
  nail_20v_t64_desc: '20V 钉枪',
  nail_20v_j80_desc: '20V 钉枪',
  nail_20v_n90_desc: '20V 线卡枪',
  nail_20v_b50_desc: '20V 钉枪',
  nail_20v_c60_desc: '20V 钉枪',
  nail_20v_d70_desc: 'D型20V锂电钉枪',
  nail_20v_e80_desc: 'E型20V锂电钉枪',
  nail_20v_g100_desc: 'G型20V锂电旗舰钉枪',
  nail_ac_f30_desc: 'AC 钉枪',
  nail_ac_f50_desc: 'AC 钉枪',
  nail_ac_t64_desc: 'AC 钉枪',
  nail_ac_j80_desc: 'AC 钉枪',
  nail_ac_n90_desc: 'AC 钉枪',
  nail_ac_b50_desc: 'AC 钉枪',
  nail_ac_c60_desc: 'C型AC电动卷钉枪',
  nail_ac_d70_desc: 'D型AC电动钉枪',
  nail_ac_e80_desc: 'E型AC电动钉枪',
  nail_ac_g100_desc: 'G型AC电动旗舰钉枪',

  'products.workshop.hero.brand': 'LEIMING TOOLS',
  'products.workshop.hero.title': '专用工坊工具系列',
  'products.workshop.hero.description': '涵盖抛光、砂磨、粘接等多种工艺需求，助力工坊高效作业，打造精品工艺',
  'products.workshop.pageHeader.title': '专用工坊工具系列',
  'products.workshop.pageHeader.description': '为专业工坊量身定制的高性能工具，从汽车抛光到表面处理，从精密粘接到材料打磨，全方位满足工坊多样化作业需求',
  'products.workshop.categories.polisher': '汽车抛光机',
  'products.workshop.categories.sander': '砂磨与表面处理',
  'products.workshop.categories.glueGun': '电热熔胶枪',
  'products.workshop.polisher.001.name': '20V 锂电双动汽车抛光机',
  'products.workshop.polisher.001.model': 'S0P-DW05-150',
  'products.workshop.polisher.001.description': '20V 锂电双动汽车抛光机',
  'products.workshop.polisher.002.name': '600W 双动抛光机',
  'products.workshop.polisher.002.model': 'S1P-DW01-180',
  'products.workshop.polisher.002.description': '600W 双动抛光机',
  'products.workshop.polisher.003.name': '125mm 迷你汽车抛光机',
  'products.workshop.polisher.003.model': 'LK-WS-POL-125-MN',
  'products.workshop.polisher.003.description': '125mm 迷你汽车抛光机',
  'products.workshop.polisher.004.name': '200mm 大盘汽车抛光机',
  'products.workshop.polisher.004.model': 'LK-WS-POL-200-LP',
  'products.workshop.polisher.004.description': '200mm 大盘汽车抛光机',
  'products.workshop.polisher.005.name': '180mm 变速汽车抛光机',
  'products.workshop.polisher.005.model': 'LK-WS-POL-180-VS',
  'products.workshop.polisher.005.description': '180mm 变速汽车抛光机',
  'products.workshop.polisher.006.name': '150mm 双模式汽车抛光机',
  'products.workshop.polisher.006.model': 'LK-WS-POL-150-DM',
  'products.workshop.polisher.006.description': '150mm 双模式汽车抛光机',
  'products.workshop.polisher.007.name': '125mm 锂电汽车抛光机',
  'products.workshop.polisher.007.model': 'LK-WS-POL-125-CL',
  'products.workshop.polisher.007.description': '125mm 锂电汽车抛光机',
  'products.workshop.polisher.008.name': '180mm 气动汽车抛光机',
  'products.workshop.polisher.008.model': 'LK-WS-POL-180-PN',
  'products.workshop.polisher.008.description': '180mm 气动汽车抛光机',
  'products.workshop.polisher.009.name': '150mm 湿式汽车抛光机',
  'products.workshop.polisher.009.model': 'LK-WS-POL-150-WT',
  'products.workshop.polisher.009.description': '150mm 湿式汽车抛光机',
  'products.workshop.polisher.010.name': '180mm 智能汽车抛光机',
  'products.workshop.polisher.010.model': 'LK-WS-POL-180-SM',
  'products.workshop.polisher.010.description': '180mm 智能汽车抛光机',
  'products.workshop.sander.001.name': '125mm 偏心轨道砂磨机',
  'products.workshop.sander.001.model': 'LK-WS-SAN-125-EO',
  'products.workshop.sander.001.description': '125mm 偏心轨道砂磨机',
  'products.workshop.sander.002.name': '150mm 随机轨道砂磨机',
  'products.workshop.sander.002.model': 'LK-WS-SAN-150-RO',
  'products.workshop.sander.002.description': '150mm 随机轨道砂磨机',
  'products.workshop.sander.003.name': '100mm 三角形细节砂磨机',
  'products.workshop.sander.003.model': 'LK-WS-SAN-100-DT',
  'products.workshop.sander.003.description': '100mm 三角形细节砂磨机',
  'products.workshop.sander.004.name': '200mm 宽幅砂带机',
  'products.workshop.sander.004.model': 'LK-WS-SAN-200-WB',
  'products.workshop.sander.004.description': '200mm 宽幅砂带机',
  'products.workshop.sander.005.name': '125mm 变速砂磨机',
  'products.workshop.sander.005.model': 'LK-WS-SAN-125-VS',
  'products.workshop.sander.005.description': '125mm 变速砂磨机',
  'products.workshop.sander.006.name': '150mm 干湿两用砂磨机',
  'products.workshop.sander.006.model': 'LK-WS-SAN-150-WD',
  'products.workshop.sander.006.description': '150mm 干湿两用砂磨机',
  'products.workshop.sander.007.name': '125mm 锂电轨道砂磨机',
  'products.workshop.sander.007.model': 'LK-WS-SAN-125-CL',
  'products.workshop.sander.007.description': '125mm 锂电轨道砂磨机',
  'products.workshop.sander.008.name': '100mm 气动掌形砂磨机',
  'products.workshop.sander.008.model': 'LK-WS-SAN-100-PN',
  'products.workshop.sander.008.description': '100mm 气动掌形砂磨机',
  'products.workshop.sander.009.name': '150mm 墙面天花板砂磨机',
  'products.workshop.sander.009.model': 'LK-WS-SAN-150-WC',
  'products.workshop.sander.009.description': '150mm 墙面天花板砂磨机',
  'products.workshop.sander.010.name': '125mm 静音轨道砂磨机',
  'products.workshop.sander.010.model': 'LK-WS-SAN-125-SL',
  'products.workshop.sander.010.description': '125mm 静音轨道砂磨机',
  'products.workshop.glueGun.001.name': '4V 锂电热熔胶枪',
  'products.workshop.glueGun.001.model': 'Q0A-DW02-4V',
  'products.workshop.glueGun.001.description': '4V 锂电热熔胶枪',
  'products.workshop.glueGun.002.name': '12V 锂电热熔胶枪',
  'products.workshop.glueGun.002.model': 'Q0A-DW02-12V',
  'products.workshop.glueGun.002.description': '12V 锂电热熔胶枪',
  'products.workshop.glueGun.003.name': '20V 锂电热熔胶枪',
  'products.workshop.glueGun.003.model': 'Q0A-DW06-20V',
  'products.workshop.glueGun.003.description': '20V 锂电热熔胶枪',
  'products.workshop.glueGun.004.name': '120W 双温热熔胶枪',
  'products.workshop.glueGun.004.model': 'LK-WS-GLU-120W-DT',
  'products.workshop.glueGun.004.description': '120W 双温热熔胶枪',
  'products.workshop.glueGun.005.name': '80W 锂电热熔胶枪',
  'products.workshop.glueGun.005.model': 'Q0A-DW02-4V-CL',
  'products.workshop.glueGun.005.description': '80W 锂电热熔胶枪',
  'products.workshop.glueGun.006.name': '100W 精密热熔胶枪',
  'products.workshop.glueGun.006.model': 'LK-WS-GLU-100W-PR',
  'products.workshop.glueGun.006.description': '100W 精密热熔胶枪',
  'products.workshop.glueGun.007.name': '150W 工业级热熔胶枪',
  'products.workshop.glueGun.007.model': 'LK-WS-GLU-150W-IN',
  'products.workshop.glueGun.007.description': '150W 工业级热熔胶枪',
  'products.workshop.glueGun.008.name': '80W 智能热熔胶枪',
  'products.workshop.glueGun.008.model': 'Q0A-DW02-4V-SM',
  'products.workshop.glueGun.008.description': '80W 智能热熔胶枪',
  'products.workshop.glueGun.009.name': '100W 双嘴热熔胶枪',
  'products.workshop.glueGun.009.model': 'LK-WS-GLU-100W-DN',
  'products.workshop.glueGun.009.description': '100W 双嘴热熔胶枪',
  'products.workshop.glueGun.010.name': '80W 长嘴热熔胶枪',
  'products.workshop.glueGun.010.model': 'Q0A-DW02-4V-LN',
  'products.workshop.glueGun.010.description': '80W 长嘴热熔胶枪',

  'products.sharpening.hero.brand': 'LEIMING TOOLS',
  'products.sharpening.hero.title': '专业磨刀系列',
  'products.sharpening.hero.description': '精密设计，高效耐用，满足各类专业磨削和雕刻需求',
  'products.sharpening.pageHeader.title': '专业磨刀系列',
  'products.sharpening.pageHeader.description': '提供全方位的磨削和雕刻解决方案，从多功能磨削工作台到精密钻头修复机，再到专业雕刻工具',
  'products.sharpening.categories.workbench': '多功能磨削工作台',
  'products.sharpening.categories.drillRepair': '钻头修复机',
  'products.sharpening.categories.engraving': '雕刻工具',
  'products.sharpening.workbench.001.name': '220W 三合一多功能打磨机',
  'products.sharpening.workbench.001.model': 'S1B-DW01-220W',
  'products.sharpening.workbench.001.description': '220W 三合一多功能打磨机',
  'products.sharpening.workbench.002.name': '多功能磨刀机',
  'products.sharpening.workbench.002.model': 'S1D-DW05-52 ',
  'products.sharpening.workbench.002.description': '多功能磨刀机',
  'products.sharpening.workbench.003.name': '160W 电磨机',
  'products.sharpening.workbench.003.model': 'S1J-DW02-160',
  'products.sharpening.workbench.003.description': '160W 电磨机',
  'products.sharpening.workbench.004.name': '20V 锂电台式砂轮机',
  'products.sharpening.workbench.004.model': 'S1S-DW03-50DC',
  'products.sharpening.workbench.004.description': '20V 锂电台式砂轮机',
  'products.sharpening.workbench.005.name': '120W 台式双头砂轮机',
  'products.sharpening.workbench.005.model': 'S1S-DW07-75',
  'products.sharpening.workbench.005.description': '120W 台式双头砂轮机',
  'products.sharpening.workbench.006.name': '便携式磨刀工作台',
  'products.sharpening.workbench.006.model': 'LK-SP-WB-PT-006',
  'products.sharpening.workbench.006.description': '便携式磨刀工作台，轻量化设计',
  'products.sharpening.workbench.007.name': '重型研磨工作台',
  'products.sharpening.workbench.007.model': 'LK-SP-WB-HD-007',
  'products.sharpening.workbench.007.description': '适用于大型工具的重型研磨工作台',
  'products.sharpening.workbench.008.name': '智能磨刀系统',
  'products.sharpening.workbench.008.model': 'LK-SP-WB-SM-008',
  'products.sharpening.workbench.008.description': '带自动角度识别的智能磨刀系统',
  'products.sharpening.workbench.009.name': '厨刀磨刀站',
  'products.sharpening.workbench.009.model': 'LK-SP-WB-KN-009',
  'products.sharpening.workbench.009.description': '专业厨刀磨刀站，操作简便',
  'products.sharpening.workbench.010.name': '工业级研磨平台',
  'products.sharpening.workbench.010.model': 'LK-SP-WB-IN-010',
  'products.sharpening.workbench.010.description': '适用于批量生产的工业级研磨平台',
  'products.sharpening.drillRepair.001.name': '三合一多功能磨钻头机',
  'products.sharpening.drillRepair.001.model': 'S1D-DW03-58',
  'products.sharpening.drillRepair.001.description': 'AC 专业级便携式钻头研磨机',
  'products.sharpening.drillRepair.002.name': '95W 电动磨钻头机',
  'products.sharpening.drillRepair.002.model': 'S1Z-DW03-75',
  'products.sharpening.drillRepair.002.description': '95W 电动磨钻头机',
  'products.sharpening.drillRepair.003.name': '95W 电动磨钻头机',
  'products.sharpening.drillRepair.003.model': 'S1Z-DW04-58',
  'products.sharpening.drillRepair.003.description': '95W 电动磨钻头机',
  'products.sharpening.drillRepair.004.name': '95W 电动磨钻头机',
  'products.sharpening.drillRepair.004.model': 'S1Z-DW08-75',
  'products.sharpening.drillRepair.004.description': '95W 电动磨钻头机',
  'products.sharpening.drillRepair.005.name': '92W 电动磨钻头机',
  'products.sharpening.drillRepair.005.model': 'S1Z-DW09-92W',
  'products.sharpening.drillRepair.005.description': '92W 电动磨钻头机',
  'products.sharpening.drillRepair.006.name': '自动钻头研磨机',
  'products.sharpening.drillRepair.006.model': 'LK-SP-DR-AT-006',
  'products.sharpening.drillRepair.006.description': '带自动进给系统的自动钻头研磨机',
  'products.sharpening.drillRepair.007.name': '高速钻头修复机',
  'products.sharpening.drillRepair.007.model': 'LK-SP-DR-HS-007',
  'products.sharpening.drillRepair.007.description': '适合快速生产的高速钻头修复机',
  'products.sharpening.drillRepair.008.name': 'CNC钻头研磨机',
  'products.sharpening.drillRepair.008.model': 'LK-SP-DR-CN-008',
  'products.sharpening.drillRepair.008.description': '带数控系统的CNC钻头研磨机',
  'products.sharpening.drillRepair.009.name': '小径钻头研磨机',
  'products.sharpening.drillRepair.009.model': 'LK-SP-DR-SM-009',
  'products.sharpening.drillRepair.009.description': '适用于小直径钻头的研磨机',
  'products.sharpening.drillRepair.010.name': '工业钻头研磨机',
  'products.sharpening.drillRepair.010.model': 'LK-SP-DR-IN-010',
  'products.sharpening.drillRepair.010.description': '适用于批量生产的工业钻头研磨机',
  'products.sharpening.engraving.001.name': '4V 锂电雕刻笔',
  'products.sharpening.engraving.001.model': 'Q0K-DW05-4V',
  'products.sharpening.engraving.001.description': '4V 锂电雕刻笔',
  'products.sharpening.engraving.002.name': '13W 电动刻字笔',
  'products.sharpening.engraving.002.model': 'Q1K-DW04-13',
  'products.sharpening.engraving.002.description': '13W 电动刻字笔',
  'products.sharpening.engraving.003.name': '精密雕刻工具套装',
  'products.sharpening.engraving.003.model': 'LK-SP-EG-PR-003',
  'products.sharpening.engraving.003.description': '含多种刀头及配件的精密雕刻工具套装',
  'products.sharpening.engraving.004.name': '锂电雕刻笔',
  'products.sharpening.engraving.004.model': 'LK-SP-EG-CL-004',
  'products.sharpening.engraving.004.description': '锂电池供电的无线雕刻笔，适合移动作业',
  'products.sharpening.engraving.005.name': '高速雕刻机',
  'products.sharpening.engraving.005.model': 'LK-SP-EG-HS-005',
  'products.sharpening.engraving.005.description': '30000转高速雕刻机，适合快速作业',
  'products.sharpening.engraving.006.name': '微型雕刻工具',
  'products.sharpening.engraving.006.model': 'LK-SP-EG-MC-006',
  'products.sharpening.engraving.006.description': '适合精细及精密作业的微型雕刻工具',
  'products.sharpening.engraving.007.name': '专业雕刻系统',
  'products.sharpening.engraving.007.model': 'LK-SP-EG-PF-007',
  'products.sharpening.engraving.007.description': '带调速及多模式的专业雕刻系统',
  'products.sharpening.engraving.008.name': '木工雕刻工具',
  'products.sharpening.engraving.008.model': 'LK-SP-EG-WD-008',
  'products.sharpening.engraving.008.description': '专为木雕设计的木工雕刻工具',
  'products.sharpening.engraving.009.name': '金属雕刻机',
  'products.sharpening.engraving.009.model': 'LK-SP-EG-MT-009',
  'products.sharpening.engraving.009.description': '用于金属表面标记与雕刻的金属雕刻机',
  'products.sharpening.engraving.010.name': '艺术雕刻工具套装',
  'products.sharpening.engraving.010.model': 'LK-SP-EG-AT-010',
  'products.sharpening.engraving.010.description': '适合创意作业的专业艺术雕刻工具套装',

  'products.gardenTools.categories.hedgeTrimmer': '链锯',
  'products.gardenTools.categories.poleSaw': '高枝及伸缩系列',
  'products.gardenTools.categories.lawnCare': '园林养护专用',
  'products.gardenTools.hedgeTrimmer.001.model': 'M0L-DW03-5C',
  'products.gardenTools.hedgeTrimmer.001.description': '12V 5寸修枝锯',
  'products.gardenTools.hedgeTrimmer.002.model': 'M0L-DW03-6C',
  'products.gardenTools.hedgeTrimmer.002.description': '20V 6寸修枝锯',
  'products.gardenTools.hedgeTrimmer.003.model': 'M0L-DW05-10C',
  'products.gardenTools.hedgeTrimmer.003.description': '20V 10寸链锯',
  'products.gardenTools.hedgeTrimmer.004.model': 'M0L-DW06-8C',
  'products.gardenTools.hedgeTrimmer.004.description': '20V 8寸无刷链锯',
  'products.gardenTools.hedgeTrimmer.005.model': 'LK-GT-CS-20V-005',
  'products.gardenTools.hedgeTrimmer.005.description': '20V锂电迷你链锯',
  'products.gardenTools.hedgeTrimmer.006.model': 'LK-GT-CS-20V-006',
  'products.gardenTools.hedgeTrimmer.006.description': '20V锂电顶杆修枝锯',
  'products.gardenTools.hedgeTrimmer.007.model': 'LK-GT-CS-20V-007',
  'products.gardenTools.hedgeTrimmer.007.description': '20V锂电绿篱修剪机',
  'products.gardenTools.hedgeTrimmer.008.model': 'LK-GT-CS-40V-008',
  'products.gardenTools.hedgeTrimmer.008.description': '40V无刷大功率链锯',
  'products.gardenTools.hedgeTrimmer.009.model': 'LK-GT-CS-20V-009',
  'products.gardenTools.hedgeTrimmer.009.description': '20V锂电伸缩修枝锯',
  'products.gardenTools.hedgeTrimmer.010.model': 'LK-GT-CS-20V-010',
  'products.gardenTools.hedgeTrimmer.010.description': '20V锂电专业修枝锯',
  'products.gardenTools.poleSaw.001.model': 'N0HX-DW01B-410',
  'products.gardenTools.poleSaw.001.description': '20V 锂电高枝绿篱机',
  'products.gardenTools.poleSaw.002.model': 'N0HC-DW01-32',
  'products.gardenTools.poleSaw.002.description': '20V伸缩高枝锯',
  'products.gardenTools.poleSaw.003.model': 'M0HL-DW08-8C',
  'products.gardenTools.poleSaw.003.description': '40V大功率高枝锯',
  'products.gardenTools.poleSaw.004.model': 'LK-GT-PP-20V-004',
  'products.gardenTools.poleSaw.004.description': '20V无刷高枝锯',
  'products.gardenTools.poleSaw.005.model': 'LK-GT-PP-20V-005',
  'products.gardenTools.poleSaw.005.description': '20V锂电多功能高枝锯',
  'products.gardenTools.poleSaw.006.model': 'LK-GT-PP-20V-006',
  'products.gardenTools.poleSaw.006.description': '20V锂电高枝绿篱机',
  'products.gardenTools.poleSaw.007.model': 'LK-GT-PP-20V-007',
  'products.gardenTools.poleSaw.007.description': '20V锂电高枝修枝机',
  'products.gardenTools.poleSaw.008.model': 'LK-GT-PP-40V-008',
  'products.gardenTools.poleSaw.008.description': '40V无刷长杆高枝锯',
  'products.gardenTools.poleSaw.009.model': 'LK-GT-PP-20V-009',
  'products.gardenTools.poleSaw.009.description': '20V锂电轻量高枝锯',
  'products.gardenTools.poleSaw.010.model': 'LK-GT-PP-20V-010',
  'products.gardenTools.poleSaw.010.description': '20V锂电专业高枝锯',

  'products.gardenTools.polePruner.001.name': 'N0HX-DW01B-410',
  'products.gardenTools.polePruner.001.description': '20V 锂电高枝绿篱机',
  'products.gardenTools.polePruner.002.name': 'N0HC-DW01-32',
  'products.gardenTools.polePruner.002.description': '20V 锂电伸缩高枝剪',
  'products.gardenTools.polePruner.003.name': 'M0HL-DW08-8C',
  'products.gardenTools.polePruner.003.description': '20V 锂电高枝修枝机',
  'products.gardenTools.polePruner.004.name': 'LK-GT-PP-20V-004',
  'products.gardenTools.polePruner.004.description': '20V无刷高枝锯',
  'products.gardenTools.polePruner.005.name': 'LK-GT-PP-20V-005',
  'products.gardenTools.polePruner.005.description': '20V锂电多功能高枝锯',
  'products.gardenTools.polePruner.006.name': 'LK-GT-PP-20V-006',
  'products.gardenTools.polePruner.006.description': '20V锂电高枝绿篱机',
  'products.gardenTools.polePruner.007.name': 'LK-GT-PP-20V-007',
  'products.gardenTools.polePruner.007.description': '20V锂电高枝修枝机',
  'products.gardenTools.polePruner.008.name': 'LK-GT-PP-40V-008',
  'products.gardenTools.polePruner.008.description': '40V无刷长杆高枝锯',
  'products.gardenTools.polePruner.009.name': 'LK-GT-PP-20V-009',
  'products.gardenTools.polePruner.009.description': '20V锂电轻量高枝锯',
  'products.gardenTools.polePruner.010.name': 'LK-GT-PP-20V-010',
  'products.gardenTools.polePruner.010.description': '20V锂电专业高枝锯',

  'products.gardenTools.lawnCare.001.model': 'S1L-DW03-104',
  'products.gardenTools.lawnCare.001.name': 'S1L-DW03-104',
  'products.gardenTools.lawnCare.001.description': '20V 锂电磨链机',
  'products.gardenTools.lawnCare.002.model': 'S0L-DW04-108',
  'products.gardenTools.lawnCare.002.name': 'S0L-DW04-108',
  'products.gardenTools.lawnCare.002.description': '85W 磨链机',
  'products.gardenTools.lawnCare.003.model': 'LK-GT-LC-40V-003',
  'products.gardenTools.lawnCare.003.name': 'LK-GT-LC-40V-003',
  'products.gardenTools.lawnCare.003.description': '40V大功率草坪修剪机',
  'products.gardenTools.lawnCare.004.model': 'LK-GT-LC-20V-004',
  'products.gardenTools.lawnCare.004.name': 'LK-GT-LC-20V-004',
  'products.gardenTools.lawnCare.004.description': '20V无刷绿篱修剪机',
  'products.gardenTools.lawnCare.005.model': 'LK-GT-LC-20V-005',
  'products.gardenTools.lawnCare.005.name': 'LK-GT-LC-20V-005',
  'products.gardenTools.lawnCare.005.description': '20V锂电草坪梳理机',
  'products.gardenTools.lawnCare.006.model': 'LK-GT-LC-20V-006',
  'products.gardenTools.lawnCare.006.name': 'LK-GT-LC-20V-006',
  'products.gardenTools.lawnCare.006.description': '20V锂电草坪打边机',
  'products.gardenTools.lawnCare.007.model': 'LK-GT-LC-20V-007',
  'products.gardenTools.lawnCare.007.name': 'LK-GT-LC-20V-007',
  'products.gardenTools.lawnCare.007.description': '20V锂电多功能园林养护机',
  'products.gardenTools.lawnCare.008.model': 'LK-GT-LC-40V-008',
  'products.gardenTools.lawnCare.008.name': 'LK-GT-LC-40V-008',
  'products.gardenTools.lawnCare.008.description': '40V无刷专业草坪修剪机',
  'products.gardenTools.lawnCare.009.model': 'LK-GT-LC-20V-009',
  'products.gardenTools.lawnCare.009.name': 'LK-GT-LC-20V-009',
  'products.gardenTools.lawnCare.009.description': '20V锂电割草机',
  'products.gardenTools.lawnCare.010.model': 'LK-GT-LC-20V-010',
  'products.gardenTools.lawnCare.010.name': 'LK-GT-LC-20V-010',
  'products.gardenTools.lawnCare.010.description': '20V锂电专业园林养护套装',

  'products.brushless.categories.drill': '螺丝刀与电钻',
  'products.brushless.categories.driver': '冲击起子机',
  'products.brushless.categories.grinder': '角磨机',
  'products.brushless.drill.001.model': 'P0L-DW01-4V',
  'products.brushless.drill.001.name': '4V 电动螺丝刀',
  'products.brushless.drill.001.description': '4V 电动螺丝刀',
  'products.brushless.drill.002.model': 'P0L-DW01B-4V',
  'products.brushless.drill.002.name': '4V 电动螺丝刀',
  'products.brushless.drill.002.description': '4V 电动螺丝刀',
  'products.brushless.drill.003.model': 'P0L-DW02-4V',
  'products.brushless.drill.003.name': '4V 电动螺丝刀',
  'products.brushless.drill.003.description': '4V 电动螺丝刀',
  'products.brushless.drill.004.model': 'J0Z-DW07-13',
  'products.brushless.drill.004.name': '20V 无刷冲击钻',
  'products.brushless.drill.004.description': '20V 无刷冲击钻',
  'products.brushless.drill.005.model': 'J0Z-DW08A-10',
  'products.brushless.drill.005.name': '12V 冲击钻',
  'products.brushless.drill.005.description': '12V 冲击钻',
  'products.brushless.drill.006.model': 'J0Z-DW09-13',
  'products.brushless.drill.006.name': '20V 无刷电钻',
  'products.brushless.drill.006.description': '20V 无刷电钻',
  'products.brushless.drill.007.model': 'P0L-DW08-12V',
  'products.brushless.drill.007.name': '12V 电钻',
  'products.brushless.drill.007.description': '12V 电钻',
  'products.brushless.drill.008.model': 'LK-BL-IW-20V-008',
  'products.brushless.drill.008.name': '20V无刷紧凑冲击扳手',
  'products.brushless.drill.008.description': '20V无刷锂电紧凑冲击扳手',
  'products.brushless.drill.009.model': 'LK-BL-ID-20V-009',
  'products.brushless.drill.009.name': '20V无刷智能冲击钻',
  'products.brushless.drill.009.description': '20V无刷锂电智能冲击钻',
  'products.brushless.drill.010.model': 'LK-BL-IW-20V-010',
  'products.brushless.drill.010.name': '20V无刷旗舰冲击扳手',
  'products.brushless.drill.010.description': '20V无刷锂电旗舰冲击扳手',
  'products.brushless.driver.001.model': 'P0L-DW05-12V',
  'products.brushless.driver.001.name': '12V 无刷冲击起子机',
  'products.brushless.driver.001.description': '12V 无刷冲击起子机',
  'products.brushless.driver.002.model': 'P0L-DW07-20V',
  'products.brushless.driver.002.name': '20V 冲击起子机',
  'products.brushless.driver.002.description': '20V 冲击起子机',
  'products.brushless.driver.003.model': 'POL-DW04M-280',
  'products.brushless.driver.003.name': '20V 无刷冲击起子机',
  'products.brushless.driver.003.description': '20V 无刷冲击起子机',
  'products.brushless.driver.004.model': 'P0B-DW02BL-500',
  'products.brushless.driver.004.name': '20V 无刷冲击扳手',
  'products.brushless.driver.004.description': '20V 无刷冲击扳手',
  'products.brushless.driver.005.model': 'P0B-DW03BL-800',
  'products.brushless.driver.005.name': '20V 无刷冲击扳手',
  'products.brushless.driver.005.description': '20V 无刷冲击扳手',
  'products.brushless.driver.006.model': 'LK-BL-DR-20V-006',
  'products.brushless.driver.006.name': '20V无刷专业起子机',
  'products.brushless.driver.006.description': '20V无刷锂电专业起子机',
  'products.brushless.driver.007.model': 'LK-BL-DR-20V-007',
  'products.brushless.driver.007.name': '20V无刷轻量起子机',
  'products.brushless.driver.007.description': '20V无刷锂电轻量起子机',
  'products.brushless.driver.008.model': 'LK-BL-DR-20V-008',
  'products.brushless.driver.008.name': '20V无刷智能起子机',
  'products.brushless.driver.008.description': '20V无刷锂电智能起子机',
  'products.brushless.driver.009.model': 'LK-BL-DR-20V-009',
  'products.brushless.driver.009.name': '20V无刷直角起子机',
  'products.brushless.driver.009.description': '20V无刷锂电直角起子机',
  'products.brushless.driver.010.model': 'LK-BL-DR-20V-010',
  'products.brushless.driver.010.name': '20V无刷旗舰起子机',
  'products.brushless.driver.010.description': '20V无刷锂电旗舰起子机',
  //角磨机
  'products.brushless.grinder.001.model': 'S0M-DW01-100',
  'products.brushless.grinder.001.name': '20V 无刷角磨机',
  'products.brushless.grinder.001.description': '20V 无刷角磨机',
  'products.brushless.grinder.002.model': 'LK-BL-AG-20V-002',
  'products.brushless.grinder.002.name': '20V无刷角磨机（125mm）',
  'products.brushless.grinder.002.description': '20V无刷锂电大盘角磨机',
  'products.brushless.grinder.003.model': 'LK-BL-AG-20V-003',
  'products.brushless.grinder.003.name': '20V无刷角磨机（150mm）',
  'products.brushless.grinder.003.description': '20V无刷锂电迷你角磨机',
  'products.brushless.grinder.004.model': 'LK-BL-AG-20V-004',
  'products.brushless.grinder.004.name': '20V无刷变速角磨机',
  'products.brushless.grinder.004.description': '20V无刷锂电变速角磨机',
  'products.brushless.grinder.005.model': 'LK-BL-AG-20V-005',
  'products.brushless.grinder.005.name': '20V无刷专业角磨机',
  'products.brushless.grinder.005.description': '20V无刷锂电专业角磨机',
  'products.brushless.grinder.006.model': 'LK-BL-AG-20V-006',
  'products.brushless.grinder.006.name': '20V无刷高速角磨机',
  'products.brushless.grinder.006.description': '20V无刷锂电高速角磨机',
  'products.brushless.grinder.007.model': 'LK-BL-AG-20V-007',
  'products.brushless.grinder.007.name': '20V无刷轻量角磨机',
  'products.brushless.grinder.007.description': '20V无刷锂电轻量角磨机',
  'products.brushless.grinder.008.model': 'LK-BL-AG-20V-008',
  'products.brushless.grinder.008.name': '20V无刷多功能角磨机',
  'products.brushless.grinder.008.description': '20V无刷锂电多功能角磨机',
  'products.brushless.grinder.009.model': 'LK-BL-AG-20V-009',
  'products.brushless.grinder.009.name': '20V无刷智能角磨机',
  'products.brushless.grinder.009.description': '20V无刷锂电智能角磨机',
  'products.brushless.grinder.010.model': 'LK-BL-AG-20V-010',
  'products.brushless.grinder.010.name': '20V无刷旗舰角磨机',
  'products.brushless.grinder.010.description': '20V无刷锂电旗舰角磨机',

  // ===== 分类特长 key（产品详情页亮点回退文本）=====

  // 钉枪 4V
  nail_4v_feature_1_title: '0.7kg 羽量级机身设计',
  nail_4v_feature_1_desc: '仅 0.7kg 自重，比一瓶水还轻，确保精细作业轻松掌控。',
  nail_4v_feature_2_title: '1000 次超长击发续航',
  nail_4v_feature_2_desc: '单次充电击发 1000 次，强劲耐力无需频繁补能。',
  nail_4v_feature_3_title: '全能型钉种兼容',
  nail_4v_feature_3_desc: '全能型三合一，适配 53#, T50# 码钉及 47#/BN1810 直钉。',
  nail_4v_feature_4_title: '优化的安全与监控',
  nail_4v_feature_4_desc: '双重保险触头配合透明储钉窗，让作业更安全专注。',
  nail_4v_feature_5_title: '多场景适用',
  nail_4v_feature_5_desc: '室内木工、家具拼装、精细装饰等多种施工场景全覆盖',

  // 钉枪 20V
  nail_20v_feature_1_title: '高功率无刷电机',
  nail_20v_feature_1_desc: '强劲无刷电机轻松穿透硬木和厚板，打钉力度稳定有力',
  nail_20v_feature_2_title: '60分钟快充',
  nail_20v_feature_2_desc: '大容量电池支持60分快充，全天高强度作业无压力',
  nail_20v_feature_3_title: '防尘防震机身',
  nail_20v_feature_3_desc: '坚固耐用的机身结构，适应各类恶劣施工环境',
  nail_20v_feature_4_title: '大容量弹匣',
  nail_20v_feature_4_desc: '110颗大容量弹匣，减少补钉频率，连续作业更顺畅',
  nail_20v_feature_5_title: '专业级品质',
  nail_20v_feature_5_desc: '满足专业施工人员和木工师傅的高标准使用需求',

  // 钉枪 AC
  nail_ac_feature_1_title: '不间断连续作业',
  nail_ac_feature_1_desc: 'AC直驱设计，无需电池，随时接电即可持续高强度作业',
  nail_ac_feature_2_title: '800W强力输出',
  nail_ac_feature_2_desc: '每秒最高1.5颗打钉速度，大规模施工效率大幅提升',
  nail_ac_feature_3_title: '稳定打钉力度',
  nail_ac_feature_3_desc: '稳定电源供给，每一颗钉的打入力度始终如一',
  nail_ac_feature_4_title: '防滑稳固底座',
  nail_ac_feature_4_desc: '稳固底座设计，确保各类作业台面上的安全操作',
  nail_ac_feature_5_title: '坚固耐用机身',
  nail_ac_feature_5_desc: '优质合金材质，经久耐用，满足长期大量使用需求',

  // 无刷 冲击钻/扳手
  brushless_drill_feature_1_title: '高性能无刷电机',
  brushless_drill_feature_1_desc: '最高80N·m扭矩，钻孔、紧固、拆卸各类作业一把搞定',
  brushless_drill_feature_2_title: '双速离合设定',
  brushless_drill_feature_2_desc: '灵活切换作业模式，精准控制力度大小',
  brushless_drill_feature_3_title: 'LED内置照明',
  brushless_drill_feature_3_desc: '内置LED灯为黑暗环境作业提供充足照明',
  brushless_drill_feature_4_title: '快锁卡盘设计',
  brushless_drill_feature_4_desc: '免工具快速更换钻头，大幅提升作业效率',
  brushless_drill_feature_5_title: '全金属精密齿轮箱',
  brushless_drill_feature_5_desc: '全金属精密齿轮箱保证高传动效率和长期耐用性',

  // 无刷 冲击起子机
  brushless_driver_feature_1_title: '最高180N·m冲击扭矩',
  brushless_driver_feature_1_desc: '强力冲击机构高效完成螺栓紧固与拆卸作业',
  brushless_driver_feature_2_title: '紧凑轻量设计',
  brushless_driver_feature_2_desc: '仅重1.3kg，轻松进入狭窄空间作业',
  brushless_driver_feature_3_title: '四速模式切换',
  brushless_driver_feature_3_desc: '四档速度精准对应各类作业场景',
  brushless_driver_feature_4_title: '三点式LED照明',
  brushless_driver_feature_4_desc: '三方向LED消除所有死角阴影，视野清晰',
  brushless_driver_feature_5_title: '快脱六角卡盘',
  brushless_driver_feature_5_desc: '快速更换各种规格批头，安装拆卸效率大幅提升',

  // 无刷 角磨机
  brushless_grinder_feature_1_title: '8500RPM高转速',
  brushless_grinder_feature_1_desc: '满足专业切割与研磨的强劲转速需求',
  brushless_grinder_feature_2_title: '智能过载保护',
  brushless_grinder_feature_2_desc: '智能电子保护系统自动保护电机不受损坏',
  brushless_grinder_feature_3_title: '软启动功能',
  brushless_grinder_feature_3_desc: '防止启动时反冲，确保操作安全稳定',
  brushless_grinder_feature_4_title: '免工具快换砂轮',
  brushless_grinder_feature_4_desc: '快脱系统无需工具即可瞬间更换砂轮片',
  brushless_grinder_feature_5_title: '多工况适用',
  brushless_grinder_feature_5_desc: '金属切割、焊缝清理、表面研磨等多种工况全覆盖',

  // 园林 电链锯/修枝锯
  garden_chainsaw_feature_1_title: '优质合金钢链条',
  garden_chainsaw_feature_1_desc: '链条速度10m/s高效切断木材，断面整齐光滑',
  garden_chainsaw_feature_2_title: '自动润滑系统',
  garden_chainsaw_feature_2_desc: '内置自动给油机构持续润滑链条，降低维护负担',
  garden_chainsaw_feature_3_title: '免工具快换导板',
  garden_chainsaw_feature_3_desc: '快脱机构轻松实现导板的快速拆装',
  garden_chainsaw_feature_4_title: '安全链条制动',
  garden_chainsaw_feature_4_desc: '瞬时响应安全制动，有效防止意外事故发生',
  garden_chainsaw_feature_5_title: '低振动人体工学设计',
  garden_chainsaw_feature_5_desc: '减振设计与符合人体工学的握把，长时间作业也不疲劳',

  // 园林 高枝锯
  garden_pole_feature_1_title: '最长3m伸缩杆',
  garden_pole_feature_1_desc: '无需梯子即可安全触达最高5m的枝条',
  garden_pole_feature_2_title: '0-60°多角度调节',
  garden_pole_feature_2_desc: '锯头多角度调节，应对各种枝条方向轻松自如',
  garden_pole_feature_3_title: '轻量化设计3.2kg',
  garden_pole_feature_3_desc: '超轻杆身材质将头顶作业的手臂疲劳降到最低',
  garden_pole_feature_4_title: '过载自动保护',
  garden_pole_feature_4_desc: '内置保护机构在过载时自动停机，保护电机安全',
  garden_pole_feature_5_title: '专业级设计',
  garden_pole_feature_5_desc: '专为果园管理和行道树修剪等专业用途优化设计',

  // 园林 园林养护
  garden_lawn_feature_1_title: '宽幅作业头',
  garden_lawn_feature_1_desc: '更大工作幅宽，单次覆盖更大面积，节省作业时间',
  garden_lawn_feature_2_title: '折叠收纳设计',
  garden_lawn_feature_2_desc: '紧凑折叠设计大幅节省存储空间',
  garden_lawn_feature_3_title: '多档高度调节',
  garden_lawn_feature_3_desc: '多档高度调节，适应不同身高用户的使用需求',
  garden_lawn_feature_4_title: '低噪音设计',
  garden_lawn_feature_4_desc: '噪音低于78dB，住宅区早晚作业也不扰邻',
  garden_lawn_feature_5_title: '无绳自由设计',
  garden_lawn_feature_5_desc: '20V锂电池供电，摆脱电线束缚，庭院各角落自由作业',

  // 工坊 抛光机
  workshop_polisher_feature_1_title: '专利双动作机构',
  workshop_polisher_feature_1_desc: '均匀细腻的研磨动作有效防止旋痕，实现完美漆面效果',
  workshop_polisher_feature_2_title: '六档速度调节',
  workshop_polisher_feature_2_desc: '从粗磨到镜面抛光全流程覆盖，速度精准可控',
  workshop_polisher_feature_3_title: '新手也能出专业效果',
  workshop_polisher_feature_3_desc: '直觉式操作设计，即使新手也能轻松达到专业级研磨效果',
  workshop_polisher_feature_4_title: '魔术贴托盘设计',
  workshop_polisher_feature_4_desc: '快速更换抛光盘，研磨工序切换更高效',
  workshop_polisher_feature_5_title: '人体工学握把',
  workshop_polisher_feature_5_desc: '舒适握感，长时间研磨作业也不易疲劳',

  // 工坊 砂磨机
  workshop_sander_feature_1_title: '精密偏心轨道设计',
  workshop_sander_feature_1_desc: '均匀专业的表面处理效果，精密轨道技术保驾护航',
  workshop_sander_feature_2_title: '高效集尘系统',
  workshop_sander_feature_2_desc: '内置集尘机构高效捕获研磨粉尘，保持作业环境整洁',
  workshop_sander_feature_3_title: '一键换砂纸',
  workshop_sander_feature_3_desc: '魔术贴式免工具瞬间更换砂纸目数',
  workshop_sander_feature_4_title: '防振手柄',
  workshop_sander_feature_4_desc: '防振设计长时间使用也不疲劳，作业更舒适',
  workshop_sander_feature_5_title: '多用途适用',
  workshop_sander_feature_5_desc: '木工精加工、涂层剥离、金属打磨等多种表面处理全适用',

  // 工坊 热熔胶枪
  workshop_glue_feature_1_title: '60秒快速升温',
  workshop_glue_feature_1_desc: '仅需60秒达到作业温度，迅速开始粘接作业',
  workshop_glue_feature_2_title: '防滴漏设计',
  workshop_glue_feature_2_desc: '专利防回流机构，松开扳机胶液即刻停止，零滴漏',
  workshop_glue_feature_3_title: '过热保护功能',
  workshop_glue_feature_3_desc: '内置过热保护传感器全程监控，使用更安全',
  workshop_glue_feature_4_title: '广泛适用场景',
  workshop_glue_feature_4_desc: '模型制作、手工艺品、家具修复、包装等多种粘接场景全覆盖',
  workshop_glue_feature_5_title: '舒适握把设计',
  workshop_glue_feature_5_desc: '人体工学握把，长时间精细粘接作业也舒适不疲劳',

  // 磨刀 磨削工作台
  sharpening_workbench_feature_1_title: '精密角度导轨',
  sharpening_workbench_feature_1_desc: '0-45°无级调节，每次磨削角度精准一致',
  sharpening_workbench_feature_2_title: '恒速磨削电机',
  sharpening_workbench_feature_2_desc: '稳定转速确保磨削面平整均匀',
  sharpening_workbench_feature_3_title: '水冷冷却系统',
  sharpening_workbench_feature_3_desc: '持续冷却防止磨削热量损坏刀刃金属组织',
  sharpening_workbench_feature_4_title: '多功能兼容',
  sharpening_workbench_feature_4_desc: '菜刀、木工工具、园林工具等各类刀具均可磨削',
  sharpening_workbench_feature_5_title: '专业级精度',
  sharpening_workbench_feature_5_desc: '满足专业厨师和木工师傅对磨刀精度与效果的高标准需求',

  // 磨刀 钻头修复机
  sharpening_drill_feature_1_title: '智能自动定位',
  sharpening_drill_feature_1_desc: '自动角度识别系统，无需手动调整即可定位最佳研磨角度',
  sharpening_drill_feature_2_title: '宽范围兼容',
  sharpening_drill_feature_2_desc: '兼容3-13mm直柄钻头',
  sharpening_drill_feature_3_title: '高精度三爪卡盘',
  sharpening_drill_feature_3_desc: '自动定心卡盘确保优秀的同轴精度',
  sharpening_drill_feature_4_title: '简易操作设计',
  sharpening_drill_feature_4_desc: '直觉式操作5分钟上手，新手也能轻松使用',
  sharpening_drill_feature_5_title: '工业级适用',
  sharpening_drill_feature_5_desc: '工厂批量修复和个人工具维护均可胜任',

  // 磨刀 雕刻工具
  sharpening_engraving_feature_1_title: '30,000RPM高速旋转',
  sharpening_engraving_feature_1_desc: '超高转速实现流畅雕刻面与卓越细节表现力',
  sharpening_engraving_feature_2_title: '无级调速控制',
  sharpening_engraving_feature_2_desc: '从慢速精密描线到高速雕刻，速度随心调节',
  sharpening_engraving_feature_3_title: '细长笔握设计',
  sharpening_engraving_feature_3_desc: '自然握感的笔型设计，长时间精密雕刻也不疲劳',
  sharpening_engraving_feature_4_title: '多材质兼容',
  sharpening_engraving_feature_4_desc: '木材、金属、玻璃、陶瓷等多种材质均可雕刻',
  sharpening_engraving_feature_5_title: '配件丰富',
  sharpening_engraving_feature_5_desc: '附多种雕刻刀头，覆盖各类雕刻风格和需求',

  // ===== 个别产品描述 key（150款）=====

  // 钉枪 4V（10款）
  product_J_120_description: 'J-120 系列是 DIY 爱好者的理想伙伴。它在 0.9kg 的机身中集成了强劲动力，每分钟 60 次的击发频率与 1000 枚的续航确保了专业水准。凭借全能的钉种兼容性与便捷的充电系统，它是现代家庭工具箱中不可或缺的便携之选。',
  product_J_125_description: 'J-125 系列重新定义了便携工具的“手感”。在 0.7kg 的羽量机身中提供每分钟 60 次的击发频率。无论是油画拉伸、家具修理还是装饰制作，1000 次的击发续航与专业精度让它成为现代家庭的理想之选，实现了便携与性能的完美统一。',
  product_J_139_description: 'J-139 系列是 DIY 爱好者的理想伙伴。它在 0.9kg 的机身中集成了强劲动力，每分钟 60 次的击发频率与 1000 枚的续航确保了专业水准。凭借全能的钉种兼容性与便捷的充电系统，它是现代家庭工具箱中不可或缺的便携之选。',
  product_J_126_description: 'J-126 系列重新定义了便携工具的“手感”。在 0.7kg 的羽量机身中提供每分钟 60 次的击发频率。无论是油画拉伸、家具修理还是装饰制作，1000 次的击发续航与专业精度让它成为现代家庭的理想之选，实现了便携与性能的完美统一。',
  product_J_153_description: 'J-153是U型骑马钉专用4V无绳钉枪。适合固定网状材料、线缆和隔热材料，连发模式可大幅提升施工速度。',
  product_lk_4v_n50_description: 'LK-4V-N50是N型卷钉适用的4V无绳钉枪。特别适合木栈道和外墙木材的固定作业，大容量弹匣有效减少补钉频率。',
  product_lk_4v_b18_description: 'LK-4V-B18是B型精装钉专用精密钉枪。橱柜和家具细部收尾作业的首选，无痕设计确保木材表面不留印记。',
  product_lk_4v_c25_description: 'LK-4V-C25是C型卷钉适用的迷你无绳钉枪。轻型框架和室内装修全场景适用，机身紧凑却能实现高精度打钉。',
  product_lk_4v_d30_description: 'LK-4V-D30是D型钉70mm适用的4V锂电钉枪。室内精装修及木工手工艺作业的好搭档，人体工学握把设计长时间使用也不疲劳。',
  product_lk_4v_e40_description: 'LK-4V-E40是E型钉80mm适用的4V多功能无绳钉枪。兼容各种厚度的木材，家装DIY到专业木工作业均可覆盖。',

  // 钉枪 20V（10款）
  product_J_128_description: 'J-128 系列重新定义了便携紧固工具。这款 20V 工具在 1.35kg 的机身中集成了重型码钉枪与精准直钉枪的功能。无论是家庭布线、屋顶施工还是家具翻新，每分钟 100 次的击发速度与坚固的金属弹夹，为您提供专业级的可靠体验。',
  product_J_129_description: 'J-129 系列重新定义了便携紧固工具。这款 20V 工具在 1.35kg 的机身中集成了重型码钉枪与精准直钉枪的功能。无论是家庭布线、屋顶施工还是家具翻新，每分钟 100 次的击发速度与坚固的金属弹夹，为您提供专业级的可靠体验。',
  product_J_133_description: '告别气泵与气管的束缚，J-133 20V 电钉枪机身轻至 1.9kg，极大减轻操作负担。其人体工程学设计与每分钟 60 次的击发速度，助您在各种作业场景中事半功倍，是便携性与工业级性能的完美结合。',
  product_J_145_description: 'J-145 系列重新定义了便携紧固工具。这款 20V 工具在 1.35kg 的机身中集成了重型码钉枪与精准直钉枪的功能。无论是家庭布线、屋顶施工还是家具翻新，每分钟 100 次的击发速度与坚固的金属弹夹，为您提供专业级的可靠体验。',
  product_J_147_description: 'J-147 20V 电缆固线枪是替代传统手锤固定的专业方案。它将 20V 动力与专为 19.5mm 电缆夹设计的机构结合。每分钟 20 次的频率与 LED 照明确保了操作的一致性与安全性，助您在各种复杂布线任务中提速 3 倍。',
  product_J_150_description: 'J-150 20V 无刷钉枪彻底终结了传统电动钉枪的动力延迟。凭借内置的压缩氮气结构，它能提供瞬时动力，将钉子精准打入各类硬木。专为专业级用户打造，在保持 2.9kg 轻量化平衡设计的同时，集成了 LED 工作灯，为您提供摆脱气管束缚的便携体验与工业级的耐用表现。',
  product_J_156_description: '告别气泵与气管的束缚，J-156 20V 电钉枪机身轻至 1.9kg，极大减轻操作负担。其人体工程学设计与每分钟 60 次的击发速度，助您在各种作业场景中事半功倍，是便携性与工业级性能的完美结合。',
  product_lk_20v_d70_description: 'LK-20V-D70是D型钉70mm适用的20V锂电钉枪。包装材料、托盘及合板固定的最佳拍档，大弹匣配合快充显著提升生产线效率。',
  product_lk_20v_e80_description: 'LK-20V-E80是E型钉80mm适用的20V多功能无绳钉枪。地板、栈道和围栏施工均有出色表现，防尘防水设计满足户外施工需求。',
  product_lk_20v_g100_description: 'LK-20V-G100是20V旗舰款顶级钉枪。G型专业钉100mm适用，智能诊断功能自动提醒维护时机，达到最高施工能力。',

  // 钉枪 AC（10款）
  product_J_112_description: ' J-112 有源电钉枪是专业人士的动力之选。插电式设计彻底打破了电池续航限制，是门窗线、橱柜及踢脚线施工的理想方案。每分钟 30 次的稳定击发与二合一兼容性，为住宅及商业精装修提供了高效且专业的可靠表现。',
  product_J_115_description: 'J-115 系列专为追求羽量级手感与可靠性平衡的用户打造。在 0.6kg 的超轻机身中集成了持续的有源动力。无论是家具翻新还是精细手工，其每分钟 30 次的频率与多钉种兼容性都能确保专业级的精准击发，是理想的现代化工具。',
  product_J_118_description: 'J-118 系列专为追求羽量级手感与可靠性平衡的用户打造。在 0.6kg 的超轻机身中集成了持续的有源动力。无论是家具翻新还是精细手工，其每分钟 30 次的频率与多钉种兼容性都能确保专业级的精准击发，是理想的现代化工具。',
  product_J_119_description: 'J-119 系列专为追求羽量级手感与可靠性平衡的用户打造。在 0.6kg 的超轻机身中集成了持续的有源动力。无论是家具翻新还是精细手工，其每分钟 30 次的频率与多钉种兼容性都能确保专业级的精准击发，是理想的现代化工具。',
  product_J_123_description: 'J-123 有源紧凑型钉枪重新定义了家居改良。仅 0.71kg 的机身专为追求专业效果的用户打造。无论是家具翻新还是节日装饰，每分钟 30 次的频率与持续动力确保了精准击发。它既能深入狭窄转角也能应对坚硬材料，是各类工作室的理想之选。',
  product_lk_ac_b50_description: 'LK-AC-B50是B型精装钉适用的AC精密钉枪。高品质室内精装收尾施工的利器，交叉线深度控制确保收尾效果精益求精。',
  product_lk_ac_c60_description: 'LK-AC-C60是C型卷钉适用的AC高效钉枪。内装板和轻钢龙骨固定施工专属机款，人体工学设计长时间作业也不疲劳。',
  product_lk_ac_d70_description: 'LK-AC-D70是D型钉70mm适用的AC工业级钉枪。大型生产线高效固定作业的首选，高耐用机身可承受24小时连续运转。',
  product_lk_ac_e80_description: 'LK-AC-E80是E型钉80mm适用的AC木栈道专用钉枪。户外木栈道和木围栏施工的理想之选，不锈钢内部机构耐受潮湿户外环境。',
  product_lk_ac_g100_description: 'LK-AC-G100是AC旗舰款顶级钉枪。G型专业钉100mm适用，最高1200W强力输出，专为专业施工现场最高性能打造。',

  // 无刷 冲击钻/扳手（10款）
  product_drill_001_description: 'P0L-DW01-4V 是您家庭组装与精细维修的得力助手。它不仅拥有 4.5Nm 的稳定扭矩输出，更创新的采用了 180° 可旋转手柄设计，只需轻轻一转，即可在枪型与直型间自由切换，轻松应对各种死角空间。机身重量仅为 0.38kg，配合高效的 USB Type-C 快速充电接口与 LED 工作灯，让您无论是在狭小的柜角还是暗处作业，都能享受轻盈、便捷且不间断的操作体验。',
  product_id_001_description: 'P0L-DW01B-4V 系列是您家庭组装与精细维修的得力助手。它不仅拥有 4.5Nm 的稳定扭矩输出，更创新的采用了 180° 可旋转手柄设计，只需轻轻一转，即可在枪型与直型间自由切换，轻松应对各种死角空间。机身重量仅为 0.38kg，配合高效的 USB Type-C 快速充电接口与 LED 工作灯，让您无论是在狭小的柜角还是暗处作业，都能享受轻盈、便捷且不间断的操作体验。',
  product_id_002_description: 'P0L-DW02-4V 是一款专为高效作业设计的直柄螺丝刀。它拥有 300rpm 的高转速和仅 0.26kg 的轻盈机身，配合 USB Type-C 快速充电与电量显示功能，让您在长时间的专业维修中也能保持精准、轻松的掌控感。',
  product_id_003_description: 'J0Z-DW07-13 是一款专为重型工程与高强度任务设计的无刷冲击钻。它在 1.45kg 的平衡机身中爆发出 100Nm 的超强扭矩，配合 13mm 全金属夹头与三模式冲击系统，无论是混凝土钻孔还是大直径螺栓紧固，都能提供无与伦比的动力支撑与耐用表现。',
  product_id_004_description: 'J0Z-DW08A-10 系列是一款兼具轻量化与工业级性能的无刷冲击钻。它在 0.79kg 的精巧机身中蕴含了 40Nm 的强劲动力，配合双速金属冲击变速箱与 10mm 无钥匙金属夹头，无论是家庭维修还是专业现场作业，都能提供稳定、精准且高效的打孔紧固体验。',
  product_id_005_description: 'J0Z-DW09-13 是一款兼具高扭矩与高便携性的专业无刷冲击钻。它在 0.85kg 的轻盈机身中提供了 60Nm 的强劲扭矩，配合 13mm 大规格全金属夹头与三模式切换系统，无论是针对金属、木材还是轻质砖石的钻孔作业，都能为您提供极其稳定且高效的性能表现。',
  product_id_006_description: 'P0L-DW08-12V 系列是一款兼具轻量化与工业级性能的无刷冲击钻。它在 0.79kg 的精巧机身中蕴含了 40Nm 的强劲动力，配合双速金属冲击变速箱与 10mm 无钥匙金属夹头，无论是家庭维修还是专业现场作业，都能提供稳定、精准且高效的打孔紧固体验。',
  product_id_007_description: 'LK-BL-MD-20V-007是混合驱动无刷钻。钻孔、紧固、研磨多功能集于一身，按作业需求随时切换模式，百搭万用。',
  product_id_008_description: 'LK-BL-CD-20V-008是无绳钻紧凑旗舰款。体型小巧却能输出最大70N·m扭矩，天花板作业和灯具安装等仰角施工也能轻松应对。',
  product_id_009_description: 'LK-BL-MX-20V-009是智能无刷冲击钻。支持蓝牙连接实时监控作业数据，扭矩、转速和电量状态一览无余。',

  // 无刷 冲击起子机（10款）
  product_idr_001_description: 'P0L-DW05-12V 是一款专为极致效率打造的 12V 无刷冲击起子机。它在 0.79kg 的羽量级机身中集成了惊人的 160Nm 扭矩，配合三档智能调速系统与快插夹头，无论是在专业木工现场还是日常设备维修中，都能为您提供无与伦比的紧固爆发力与灵活的操作感。',
  product_idr_002_description: 'P0L-DW07-20V 是一款极具性能优势的冲击起子机。它在 0.79kg 的轻量化设计中实现了 150Nm 的大扭矩输出，配合成熟的动力系统与快插夹头，是专业现场与家庭DIY中进行快速紧固作业的可靠选择。',
  product_idr_003_description: 'P0L-DW04M-280 是该系列的旗舰型号，将 280Nm 的惊人动力与 1.2kg 的轻量机身完美结合。凭借其三档智能调速系统与工业级无刷技术，它能够轻松胜任从大型木构建筑到金属框架组装的所有重型挑战。',
  product_idr_004_description: 'P0B-DW02BL-500 是一款为专业技师打造的重型无刷冲击扳手。它在 1.2kg 的紧凑机身中融入了 500Nm 的惊人动力，配合智能反转自停技术与 1/2" 工业级夹头，无论是大型钢构组装还是轮胎快速拆装，都能提供稳定、安全且高效的性能表现。',
  product_idr_005_description: 'P0B-DW03BL-800 是一款为重载作业重塑标准的无刷冲击扳手。它凭借 850Nm 的巅峰动力与专业级反转自停技术，在 1.9kg 的机身中实现了效率与安全的平衡，是大型钢结构、汽车工业及矿山机械维护领域的高效作业利器。',
  product_idr_006_description: 'LK-BL-IDR-20V-006是专业级无刷冲击起子机。电子扭矩管理自动补偿过紧或过松，精密施工场景的专属机型。',
  product_idr_007_description: 'LK-BL-IDR-20V-007是轻量化无刷冲击起子机。整机仅1.1kg超轻设计，仰角作业也不酸臂，长时间细部施工的绝佳搭档。',
  product_idr_008_description: 'LK-BL-IDR-20V-008是智能无刷冲击起子机。电子控制离合器自动感知拧紧完成并停机，避免螺丝头滑牙，精密打钉的可靠之选。',
  product_idr_009_description: 'LK-BL-IDR-20V-009是直角头无刷冲击起子机。专攻狭窄管道空间和墙角的直角拧紧作业，电气和管道工程的得力助手。',
  product_idr_010_description: 'LK-BL-IDR-20V-010是旗舰级无刷冲击起子机。最大250N·m扭矩配合智能蓝牙控制，引领专业施工最高水准的顶级机型。',

  // 无刷 角磨机（10款）
  product_ag_001_description: '100mm无刷锂电角磨机。金属切割、表面研磨和焊缝清理的紧凑机型，轻量化设计单手操控也能稳定作业。',
  product_ag_002_description: '125mm无刷锂电角磨机标准款。支持多种切割片，各类材料切割和研磨作业均可胜任。',
  product_ag_003_description: '150mm无刷锂电大盘角磨机。更宽切割面加速材料加工效率，适合重型作业的强劲机款。',
  product_ag_004_description: '125mm变速无刷角磨机。低速到高速五档调节，可针对不同材料选择最优加工速度。',
  product_ag_005_description: '125mm旗舰无刷角磨机。搭载电子软启动和防踢回保护功能，安全性优先的专业施工款。',
  product_ag_006_description: '125mm静音无刷角磨机。噪音抑制技术让住宅区作业更安心，振动同步减少，长时间作业也不易疲劳。',
  product_ag_007_description: '100mm紧凑无刷角磨机。轻量化小体型，专攻狭窄空间和角落的研磨，单手操控稳定如一。',
  product_ag_008_description: '125mm多功能无刷角磨机。切割、研磨、抛光三合一的全能款，支持多种配件替换。',
  product_ag_009_description: '125mm智能无刷角磨机。电子负荷感应功能根据作业负载自动调整输出，加工质量稳定可靠。',
  product_ag_010_description: '125mm旗舰无刷角磨机。相当于1200W最大输出的无刷电机配合智能控制系统，达到最高水准的顶级机型。',

  // 园林 电链锯/修枝锯（10款）
  product_ht_001_description: 'M0L-DW03-5C 将极致的轻量化与强悍动力完美融合。仅 1.32kg 的羽量级机身，搭载 8m/s 高速电机，专为果园修剪与园林精细维护而生。其出色的人体工学手柄确保了卓越的单手掌控感，让您在复杂狭小的空间内也能游刃有余。',
  product_ht_002_description: 'M0L-DW03-6C 在灵活操控与切割效能之间取得了黄金平衡。升级后的 160mm 导板赋予了它更广的作业半径，能够从容应对中等直径的枝干清理任务。1.43kg 的机身在保持便携的同时，能提供稳定且持久的动力输出。',
  product_ht_003_description: 'M0L-DW05-10C 重新定义了手持式链锯的性能上限。凭借 10m/s 的强悍链速与 270ml 超大容量油箱，它能提供媲美重型油锯的作业体验。专为繁重的伐木与场地清理打造，双手稳固掌控结构确保了在高负载作业下的极致稳定与安全。',
  product_ht_004_description: 'M0L-DW06-8C 是一款蕴含强大爆发力的“性能小钢炮”。在 1.7kg 的精巧配重下，集成了 190mm 加长导板与智能自动油泵系统。它确保链条在高强度切割中始终保持巅峰润滑，是力量感与便携性的终极合体。',
  product_ht_005_description: '20V迷你锂电链锯。6英寸小巧导板专攻果树细枝修剪和庭院轻作业，女性用户也能轻松驾驭的轻量化设计。',
  product_ht_006_description: '20V顶杆链锯。伸缩杆最长延伸至4m，无需梯子安全触达高枝，多档高度调节应对各种枝条角度。',
  product_ht_007_description: '20V锂电绿篱修剪机。500mm长刀片让大型绿篱修剪效率倍增，双面刀刃设计实现平整光滑的剪切截面。',
  product_ht_008_description: '40V无刷大型链锯。专业林业最大功率款，450mm导板配合高速链条，林业伐木和大型作业全面覆盖。',
  product_ht_009_description: '20V伸缩修枝锯。200mm锯头搭配伸缩手柄，可触达2.5m高枝，多角度调节头适应各方向枝条。',
  product_ht_010_description: '20V专业修枝锯。为职业绿化工设计的高耐用款，强化链条与大容量电池支持长时间连续作业。',

  // 园林 高枝锯（10款）
  product_pp_001_description: 'N0HX-DW01B-410 让高空作业告别了笨重的梯子与安全隐患。近 3 米的作业半径配合 11 档可调节旋转刀头，赋予了您全方位的修剪视野与角度。410mm 的优质合金导板确保每一剪都精准平整，是处理高大异形绿篱的专业利器。',
  product_pp_002_description: 'N0HC-DW01-32 是处理密集树冠中枯死枝条的“外科手术刀”。具备 32mm 的超大切割口径，配合 5 档多角度偏转系统，即使隐藏在错综复杂枝干深处的难题也能迎刃而解。铝合金轻量化长杆设计极大缓解了肩颈压力。',
  product_pp_003_description: 'M0HL-DW08-8C 是重型高空清理任务的终极解决方案。它将 200mm 的锯切能力挂载于 2.7 米的伸缩长杆之上，专为远距离移除大直径干木而设计。内置 80ml 自动润滑油箱与增强型双手柄支架，确保在极限伸展状态下依然拥有稳健的切入感。',
  product_pp_004_description: '20V轻量化无绳高枝锯。铝合金杆身将整机控制在2.8kg，长时间仰角作业也不令手臂酸痛。',
  product_pp_005_description: '20V重工无绳高枝锯。应对粗壮枝条的强力款，200mm导板配合高速链条，直径80mm以上粗枝不在话下。',
  product_pp_006_description: '20V折叠收纳高枝锯。杆身可折叠成紧凑尺寸方便收纳，装车运输和节省存储空间均表现出色。',
  product_pp_007_description: '20V专业无绳高枝锯。面向职业园林工的高耐用高性能款，大容量电池和强力电机支持长时间连续作业。',
  product_pp_008_description: '20V智能无绳高枝锯。电子负荷检测根据枝条粗细自动调整输出，有效防止卡链，切割高效省力。',
  product_pp_009_description: '20V人体工学无绳高枝锯。握把与杆身重量平衡经过最优设计，长时间庭木养护作业也不易疲劳。',
  product_pp_010_description: '20V多功能无绳高枝锯。链锯头和绿篱机头两种配件任意切换，一机完成多种高空修剪作业。',

  // 园林 园林养护（10款）
  product_lc_001_description: 'S1L-DW03-104 是确保您工具库始终保持巅峰状态的维护基石。5000rpm 的高速电机配合 +/- 35° 的精准刻度调节，让每一节链条都能恢复如新的锋利。内置 LED 照明系统消除了视野死角，重启保护功能则为作业提供了坚实的工业安全保障。',
  product_lc_002_description: 'S0L-DW04-108 专为追求极致维护速度的专业现场而生。转速飙升至 6500/min，配合仅 1.65kg 的轻量化机身，实现了移动作业与巅峰效能的平衡。它是高强度工地维护的理想搭档，确保您的链锯在最短时间内重返战场。',
  product_lc_003_description: '40V大功率无绳草坪机。380mm宽幅割刀适合大面积庭院养护，大容量电池单次充电即可覆盖更广面积。',
  product_lc_004_description: '20V无刷无绳绿篱机。600mm长刀片让绿篱整形效率倍增，电子调速功能按枝条粗细灵活调整。',
  product_lc_005_description: '20V无绳草坪梳理机。专为改善草坪通气和清除枯草设计，定期梳理作业让草坪健康生长。',
  product_lc_006_description: '20V无绳草坪打边机。将草坪边缘垂直修剪整齐，打造美观边界线，路缘石和步道边缘收尾的利器。',
  product_lc_007_description: '20V多功能无绳庭院养护套装。割草、打边、吹叶三合一，单机完成庭院收尾养护全流程。',
  product_lc_008_description: '40V无刷专业级无绳草坪机。大型庭院、公园及高尔夫球场周边草坪养护的专业款，高耐用设计支持长期专业使用。',
  product_lc_009_description: '20V无绳割草机。尼龙刀和金属刀双模式切换，杂草、细灌木和茂密丛林均可割除，用途广泛。',
  product_lc_010_description: '20V专业无绳综合庭院养护套装。含充电器、备用电池及多种配件，一套搞定全部庭院养护需求。',

  // 工坊 汽车抛光机（10款）
  product_pol_001_description: '这是一款集 LCD 智控数显、恒功率补偿与 8mm 偏心技术于一体的 20V 专业抛光机，是追求极致镜面效果与高效修复的理想之选。',
  product_pol_002_description: '150mm旋转式汽车抛光机。大功率旋转电机专攻深划痕去除和漆面快速研磨，汽车美容专业人士的首选。',
  product_pol_003_description: '125mm迷你汽车抛光机。紧凑尺寸专为狭窄面板、保险杠和后视镜研磨设计，轻量化设计细部作业也不累手。',
  product_pol_004_description: '200mm大盘汽车抛光机。更大盘面覆盖车顶和机盖等大面积区域，作业时间大幅缩短的专业款。',
  product_pol_005_description: '180mm变速汽车抛光机。1500-6800OPM宽速度范围，粗磨到最终收尾一机全覆盖，电子调速保持研磨品质稳定。',
  product_pol_006_description: '150mm双模式汽车抛光机。旋转和双动作模式一键切换，按作业需求选择最优研磨动作的全能款。',
  product_pol_007_description: '125mm无绳汽车抛光机。20V锂电驱动无需电源线，可随处移动研磨，户外手工艺作业也能尽情发挥。',
  product_pol_008_description: '180mm气动抛光机。接气泵使用的稳定气源驱动专业汽修厂款，轻量化机身持续运转表现出色。',
  product_pol_009_description: '150mm湿式汽车抛光机。特殊防水设计专为湿磨作业打造，追求完美镜面效果的专业人士专属款。',
  product_pol_010_description: '180mm智能汽车抛光机。自动控温维持最优粘接温度，过热防护传感器和自动休眠功能让使用更安全的智能机型。',

  // 工坊 砂磨机（10款）
  product_san_001_description: '125mm偏心轨道砂磨机标准款。精密偏心动作实现均匀木材表面处理，魔术贴砂纸支持快速更换。',
  product_san_002_description: '150mm随机轨道砂磨机。随机轨道运动去除研磨纹，实现自然质感的表面效果，木材最终收尾和涂装前处理的首选。',
  product_san_003_description: '100mm三角形细节砂磨机。专攻角落和细部研磨的三角形砂盘设计，家具、橱柜和窗框等复杂形状的收尾利器。',
  product_san_004_description: '200mm宽幅砂带机。超宽砂带专为大面积快速研磨设计，地板、大型板材和桌面的大量研磨作业最优之选。',
  product_san_005_description: '125mm变速砂磨机。4000-12000OPM调速范围按材质选择最优研磨速度，从精细素材到粗加工均能应对。',
  product_san_006_description: '150mm干湿两用砂磨机。特殊防水设计同时支持干式和湿式研磨，汽车面板水研磨和防水素材打磨场景中表现突出。',
  product_san_007_description: '125mm无绳轨道砂磨机。20V锂电供电无需电源线，可随处移动研磨，户外木工作业和现场收尾施工的最优之选。',
  product_san_008_description: '100mm气动掌形砂磨机。接气泵的轻量紧凑款，单手操控轻松完成细部研磨作业的专业工具。',
  product_san_009_description: '150mm墙面天花板砂磨机。可接伸缩杆的特殊设计专为墙面和天花板研磨与涂层剥离设计，翻新施工中大放异彩的独特机款。',
  product_san_010_description: '125mm静音砂磨机。隔音设计实现比传统款低30%噪音，住宅室内和夜间木工作业的静音利器。',

  // 工坊 热熔胶枪（10款）
  product_glue_001_description: '这是一款集 15 秒极速预热与 0.25kg 轻盈机身于一体的 4V 无线热熔胶枪，是您高效完成创意手工与居家修补的理想利器。',
  product_glue_002_description: '这是一款将 15 秒极速预热与超强续航完美结合的 12V 专业级热熔胶枪，是工业修补与重型 DIY 创作的高效伴侣。',
  product_glue_003_description: '这是一款搭载全自动进料系统的 20V 旗舰级热熔胶枪，凭借 13g/min 的工业级出胶速度，完美胜任重型装修、木工装配及大型创意制作。',
  product_glue_004_description: '120W双温热熔胶枪。低温高温两档切换灵活应对各类素材的粘接，从娇嫩花材到硬质素材全覆盖。',
  product_glue_005_description: '80W无绳热熔胶枪。20V锂电驱动无需电源线，可随处移动粘接，户外手工艺作业也能灵活应对的高机动性机型。',
  product_glue_006_description: '100W精密热熔胶枪。细口精密嘴头支持微量精准涂胶，精密模型、电子元件固定和花艺设计的专属利器。',
  product_glue_007_description: '150W工业热熔胶枪。大功率大出胶量的专业款，包装生产线和大型手工艺制作的批量粘接需求均可满足。',
  product_glue_008_description: '80W智能热熔胶枪。自动控温维持最优粘接温度，过热防护传感器和自动休眠功能让使用更安全的智能机型。',
  product_glue_009_description: '100W双嘴热熔胶枪。独特双嘴快速切换设计，细部精准涂胶和大面积快速涂胶随时切换，一机两用。',
  product_glue_010_description: '80W长嘴热熔胶枪。150mm超长嘴头将胶液注入深处和狭缝，电子元件粘接和深部修复作业的独特利器。',

  // 磨刀 多功能工作台（10款）
  product_wb_001_description: '这是一款集三种砂光模式于一体的 220W 智能调速砂光机，凭借强效吸尘与极致的人体工学，让复杂的表面处理变得轻快、精准且洁净。',
  product_wb_002_description: '这是一款集钻头修复、刀具开刃与凿子研磨于一体的 65W 多功能磨刀机，凭借其精准的角度调节系统，让您的工具始终保持巅峰锋利状态。',
  product_wb_003_description: '这是一款集 40,000rpm 澎湃动力与 42 件全能附件于一体的 160W 专业电磨套装，是手工 DIY、精密模型制作及艺术创作的高效全能工作站。',
  product_wb_004_description: 'S1S-DW03-50DC 是一款将 20V 无线便利性与工业级磨削效能结合的台式磨削机。凭借 9000 rpm 的高转速和双目数砂轮配置，它是金属刃具修整、小型零件打磨及 DIY 创作的理想专业工具。',
  product_wb_005_description: 'S1S-DW07-75 是一款专为精密加工设计的 120W 交流电台式磨砂抛光工作站。它集成了双轮磨抛系统与软轴操控功能，凭借 11,500 rpm 的强劲输出，是珠宝修复、模型加工及金属零件精修的理想专业工具。',
  product_wb_006_description: '便携式磨刀工作台。折叠设计仅重4kg，移动方便，现场磨刀和户外作业均可适用的移动式机型。',
  product_wb_007_description: '重工研磨工作台。大型砂轮和强力电机组合，专为大型工具和厚刃的大批量研磨设计，锻造工坊和专业工具维护机构的首选。',
  product_wb_008_description: '智能磨刀系统。AI角度识别自动判别刃具形状并推荐最优磨削程序，数字化管理提升研磨可复现性。',
  product_wb_009_description: '厨刀专用磨刀站。兼容日式、中式和西式三类厨刀形态的系统，让家庭厨房维持专业级刀刃锋利度的易用机型。',
  product_wb_010_description: '工业研磨平台。满足批量生产线定期批量磨刃需求，高产量与一致质量管理并举的专业工厂机型。',

  // 磨刀 钻头修复机（10款）
  product_dr_001_description: 'S1S-DW07-75 是一款专为精密加工设计的交流电台式工作站。它巧妙地将台式磨床的稳定性与软轴工具的灵活性结合在一起，凭借 120W 的可靠功率 与双透明安全护目镜设计，为模型制作、珠宝翻新及小型零件修整提供了一个高效、安全的专业环境。',
  product_dr_002_description: 'S1Z-DW03-75 是一款专为高效修复损耗钻头而设计的 95W 交流电磨钻机。凭借其精准的定位孔设计和稳定的动力输出，即使是新手也能轻松完成 3-12mm 钻头的研磨工作，是提升工具使用寿命和施工效率的理想助手。',
  product_dr_003_description: 'S1Z-DW04-58 是一款紧凑型 95W 交流电台式磨钻机。它结合了高精度定位导向与稳定的动力输出，能够快速将钝化的 Ф3-10mm 钻头恢复至专业切削水平，是寻求高效、高性价比工具维护方案的专业人士的首选。',
  product_dr_004_description: 'S1Z-DW08-75 是一款针对 3-13mm 常用规格设计的专业磨钻机。它在保持 95W 高效动力的同时，通过结构优化提供了更大的夹持范围，是工坊中修复钝化钻头、保持作业精度的可靠方案。',
  product_dr_005_description: 'S1Z-DW09-92W 是一款专为重度使用和工业级精度设计的钻头研磨站。它具备115°-140°的可调节顶角功能，配合 92W 的稳定交流动力和钻石研磨技术，能够高效处理高达 19mm 的大尺寸钻头，是工厂维修间和高级工坊的理想配置。',
  product_dr_006_description: '自动进给钻头研磨机。自动进给系统实现无需技能即可品质稳定一致的研磨，预设研磨量和角度自动处理。',
  product_dr_007_description: '高速钻头修复机。高速研磨循环每支钻头30秒以内快速修复，大批量钻头短时间处理的生产线专属机型。',
  product_dr_008_description: 'CNC钻头研磨机。数控全自动研磨系统，程序记忆多种研磨参数可随时调用再现的智能机型。',
  product_dr_009_description: '小径钻头研磨机。专为0.5-6mm细径钻头修复设计的精密机型，PCB制造和精密机械加工的超精细小径钻专用款。',
  product_dr_010_description: '工业钻头研磨机。兼容HSS、硬质合金和钴钢各类材质钻头的高耐用产业款，制造工厂大批量钻头维护管理的首选。',

  // 磨刀 雕刻工具（10款）
  product_eg_001_description: 'Q0K-DW05-4V 是一款将极致便携与多功能性结合的锂电电刻笔。它支持 3.2mm 通用夹头，配合高达 19000/min 的冲程速度和灵活的 6 档调节，是专业标记、手工艺制作及家庭 DIY 的理想无绳解决方案。',
  product_eg_002_description: 'Q1K-DW04-13 是一款专为高精度标记设计的交流电刻字机。无论是工业零件的防伪编号，还是礼品的个性化签名，其稳定的动力输出与轻巧的机身都能为你提供专业级的雕刻体验。',
  product_eg_003_description: '精密雕刻工具套装。主机附带20种以上专用钻头的完整套装，雕刻、研磨、抛光、切割等各类作业全覆盖的入门到进阶套装。',
  product_eg_004_description: '无绳锂电雕刻笔。20V电池驱动无绳自由雕刻，户外艺术创作和现场刻字作业也能灵活应对的高机动性机型。',
  product_eg_005_description: '30,000RPM高速雕刻机。超高转速实现玻璃、陶瓷、石材雕刻，追求极致细节表现的专业玻璃工匠和珠宝师专属机型。',
  product_eg_006_description: '微型雕刻工具。适应0.3mm以下超精细加工的精密款，珠宝制作、钟表修复和电子元件精密刻印的特殊利器。',
  product_eg_007_description: '专业雕刻系统。搭载电子调速和多雕刻模式的专业级机型，雕刻工作室和手工艺工坊专业人士所追求的精度与耐用性兼备。',
  product_eg_008_description: '木工雕刻专用工具。针对木材纤维特性优化的专属钻头形状和控制设计，木工师傅和木雕爱好者的木材雕刻专属机型。',
  product_eg_009_description: '金属雕刻机。专攻钢、铝、铜等金属表面的刻字、装饰和标记，工业品序列号刻制和金属工艺品装饰的利器。',
  product_eg_010_description: '艺术雕刻工具套装。初学到进阶艺术创作者均适用的综合创作套装，附详细使用指南和丰富样板集的学习专属套装。',
};
